//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IClient {
    /**
     * @param code (optional) 
     * @param callbackUrlOverride (optional) 
     * @return Success
     */
    callback(code?: string | undefined, callbackUrlOverride?: string | undefined): Promise<CoreAuthData>;
    /**
     * @return Success
     */
    refreshToken(userId: string, refreshToken: string): Promise<CoreAuthData>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createCustomer(body?: CreateCustomerRequestBase | undefined): Promise<CustomerInfo>;
    /**
     * @return Success
     */
    listCustomers(): Promise<CustomerInfo[]>;
    /**
     * @return No Content
     */
    deleteCustomer(id: string): Promise<void>;
    /**
     * @return Success
     */
    getCustomer(id: string): Promise<CustomerInfo>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateCustomer(id: string, body?: EditCustomerRequestBase | undefined): Promise<void>;
    /**
     * @return Success
     */
    getDirectory(projectId: string, id: string): Promise<Directory360>;
    /**
     * @return Success
     */
    getFile(projectId: string, id: string): Promise<File360>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFiles(projectId: string, body?: string[] | undefined): Promise<File360[]>;
    /**
     * @param recursive (optional) 
     * @param fileExtensions (optional) 
     * @return Success
     */
    listFiles(projectId: string, directoryId: string, recursive?: boolean | undefined, fileExtensions?: string[] | undefined): Promise<ListFilesResult>;
    /**
     * @return Success
     */
    listRecentFiles(): Promise<JobFile[]>;
    /**
     * @param includeNonProjectFiles (optional) 
     * @return Success
     */
    listTopLevelDirectories(hubId: string, projectId: string, includeNonProjectFiles?: boolean | undefined): Promise<Directory360[]>;
    /**
     * @return Success
     */
    heartbeat(): Promise<HealthStatus>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createJob(body?: CreateJobRequestBase | undefined): Promise<JobBase>;
    /**
     * @return Success
     */
    getJobs(): Promise<JobBase[]>;
    /**
     * @return No Content
     */
    deleteJob(id: string): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editJob(id: string, body?: EditJobRequestBase | undefined): Promise<JobBase>;
    /**
     * @return Success
     */
    getJob(id: string): Promise<JobBase>;
    /**
     * @return Success
     */
    getJobRun(jobRunId: string): Promise<JobRunBase>;
    /**
     * @return Success
     */
    startJob(jobId: string): Promise<JobRunBase>;
    /**
     * @param includeLegacyHubs (optional) 
     * @return Success
     */
    listHubs(includeLegacyHubs?: boolean | undefined): Promise<Hub[]>;
    /**
     * @return Success
     */
    getProject(hubId: string, projectId: string): Promise<Project>;
    /**
     * @param includeLegacyHubs (optional) 
     * @return Success
     */
    listAll(includeLegacyHubs?: boolean | undefined): Promise<Project[]>;
    /**
     * @param includeLegacyHubs (optional) 
     * @return Success
     */
    listImages(includeLegacyHubs?: boolean | undefined): Promise<Project[]>;
    /**
     * Gets the Revit version of a file from the Model Derivatives API.
     * @param userId (optional) The user ID.
     * @param projectId (optional) The project ID.
     * @param fileId (optional) The file ID.
     * @param region (optional) The region, optionally. Defaults to US.
     * @return Success
     */
    getRevitVersion(userId?: string | undefined, projectId?: string | undefined, fileId?: string | undefined, region?: string | undefined): Promise<RvtVersionResponse>;
    /**
     * Lists files and directories for the given project and query parameters.
     * @param projectId The project ID.
     * @param directoryId The directory ID from which to list files. To list files for the whole project, set this to
    the root directory ID, and leave recursive set to its default value of true.
     * @param recursive (optional) Whether to perform the search recursively, or only list files in the given folder. Defaults to
    true.
     * @param fileExtensions (optional) A collection of file extensions to filter for, optionally.
     * @param nameFilter (optional) File or folder name to filter for, optionally.
     * @return Success
     */
    listFilesTest(projectId: string, directoryId: string, recursive?: boolean | undefined, fileExtensions?: string[] | undefined, nameFilter?: string | undefined): Promise<ListFilesResult>;
    /**
     * Uploads a file to Forge.
     * @param projectId (optional) The project ID.
     * @param directoryId (optional) The directory ID.
     * @param formFiles (optional) 
     * @return Accepted
     */
    uploadFile(projectId?: string | undefined, directoryId?: string | undefined, formFiles?: FileParameter[] | undefined): Promise<void>;
    /**
     * Uploads a file to S3.
     * @param bucket (optional) The project ID.
     * @param formFiles (optional) 
     * @return Accepted
     */
    uploadFileToAws(bucket?: string | undefined, formFiles?: FileParameter[] | undefined): Promise<void>;
    /**
     * @param includeRuns (optional) 
     * @param limit (optional) 
     * @param paginationToken (optional) 
     * @param filter_CustomerIds (optional) 
     * @param filter_UserIds (optional) 
     * @param filter_JobIds (optional) 
     * @param filter_StartTime (optional) 
     * @param filter_EndTime (optional) 
     * @param sort_SortType (optional) 
     * @param sort_Ascending (optional) 
     * @return Success
     */
    getUsageSummary(includeRuns?: boolean | undefined, limit?: number | undefined, paginationToken?: string | undefined, filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | undefined, filter_EndTime?: Date | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined): Promise<UsageSummaryBase>;
    /**
     * @param filter_CustomerIds (optional) 
     * @param filter_UserIds (optional) 
     * @param filter_JobIds (optional) 
     * @param filter_StartTime (optional) 
     * @param filter_EndTime (optional) 
     * @param sort_SortType (optional) 
     * @param sort_Ascending (optional) 
     * @return Success
     */
    startCsvDownload(filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | undefined, filter_EndTime?: Date | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined): Promise<StartCsvDownloadResult>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getCsvDownload(id?: string | undefined): Promise<UsageDownloadDto>;
    /**
     * @param limit (optional) 
     * @param paginationToken (optional) 
     * @param filter_CustomerIds (optional) 
     * @param filter_UserIds (optional) 
     * @param filter_JobIds (optional) 
     * @param filter_StartTime (optional) 
     * @param filter_EndTime (optional) 
     * @param sort_SortType (optional) 
     * @param sort_Ascending (optional) 
     * @return Success
     */
    getDetailedUsage(limit?: number | undefined, paginationToken?: string | undefined, filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | undefined, filter_EndTime?: Date | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined): Promise<DetailedUsageBase>;
    /**
     * @return Success
     */
    getUserAccounts(): Promise<UserAccount[]>;
    /**
     * @return Success
     */
    getUserInfo(): Promise<UserBase>;
    /**
     * @param x_adsk_signature (optional) 
     * @param body (optional) 
     * @return Success
     */
    userWebhookCallback(x_adsk_signature?: string | undefined, body?: GDPRWebhook | undefined): Promise<GDPRWebhookResponse>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createWebhook(body?: CreateWebhookRequest | undefined): Promise<Webhook>;
    /**
     * @param eventType (optional) 
     * @param folderId (optional) 
     * @param region (optional) 
     * @param system (optional) 
     * @return Success
     */
    listWebhooks(eventType?: WebhookEvent | undefined, folderId?: string | undefined, region?: string | undefined, system?: string | undefined): Promise<Webhook[]>;
    /**
     * @return No Content
     */
    deleteUserWebhooks(): Promise<void>;
    /**
     * @return No Content
     */
    deleteUserWebhooksAdmin(userId: string): Promise<void>;
    /**
     * @return No Content
     */
    deleteWebhook(id: string): Promise<void>;
    /**
     * @return Success
     */
    getWebhook(id: string): Promise<Webhook>;
    /**
     * @return No Content
     */
    deleteWebhookAdmin(userId: string, id: string): Promise<void>;
    /**
     * @param eventType (optional) 
     * @param folderId (optional) 
     * @param region (optional) 
     * @param system (optional) 
     * @return Success
     */
    listWebhooksAdmin(userId: string, eventType?: WebhookEvent | undefined, folderId?: string | undefined, region?: string | undefined, system?: string | undefined): Promise<Webhook[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    webhookCallback(body?: WebhookBody | undefined): Promise<void>;
}

export class Client implements IClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param code (optional) 
     * @param callbackUrlOverride (optional) 
     * @return Success
     */
    callback(code?: string | undefined, callbackUrlOverride?: string | undefined , cancelToken?: CancelToken | undefined): Promise<CoreAuthData> {
        let url_ = this.baseUrl + "/api/v1/auth/callback?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (callbackUrlOverride === null)
            throw new Error("The parameter 'callbackUrlOverride' cannot be null.");
        else if (callbackUrlOverride !== undefined)
            url_ += "callbackUrlOverride=" + encodeURIComponent("" + callbackUrlOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCallback(_response);
        });
    }

    protected processCallback(response: AxiosResponse): Promise<CoreAuthData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CoreAuthData.fromJS(resultData200);
            return Promise.resolve<CoreAuthData>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoreAuthData>(null as any);
    }

    /**
     * @return Success
     */
    refreshToken(userId: string, refreshToken: string , cancelToken?: CancelToken | undefined): Promise<CoreAuthData> {
        let url_ = this.baseUrl + "/api/v1/auth/refresh/{userId}/{refreshToken}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (refreshToken === undefined || refreshToken === null)
            throw new Error("The parameter 'refreshToken' must be defined.");
        url_ = url_.replace("{refreshToken}", encodeURIComponent("" + refreshToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<CoreAuthData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CoreAuthData.fromJS(resultData200);
            return Promise.resolve<CoreAuthData>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoreAuthData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createCustomer(body?: CreateCustomerRequestBase | undefined , cancelToken?: CancelToken | undefined): Promise<CustomerInfo> {
        let url_ = this.baseUrl + "/api/v1/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCustomer(_response);
        });
    }

    protected processCreateCustomer(response: AxiosResponse): Promise<CustomerInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = CustomerInfo.fromJS(resultData201);
            return Promise.resolve<CustomerInfo>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerInfo>(null as any);
    }

    /**
     * @return Success
     */
    listCustomers(  cancelToken?: CancelToken | undefined): Promise<CustomerInfo[]> {
        let url_ = this.baseUrl + "/api/v1/customer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCustomers(_response);
        });
    }

    protected processListCustomers(response: AxiosResponse): Promise<CustomerInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerInfo[]>(null as any);
    }

    /**
     * @return No Content
     */
    deleteCustomer(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCustomer(_response);
        });
    }

    protected processDeleteCustomer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCustomer(id: string , cancelToken?: CancelToken | undefined): Promise<CustomerInfo> {
        let url_ = this.baseUrl + "/api/v1/customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomer(_response);
        });
    }

    protected processGetCustomer(response: AxiosResponse): Promise<CustomerInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerInfo.fromJS(resultData200);
            return Promise.resolve<CustomerInfo>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerInfo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateCustomer(id: string, body?: EditCustomerRequestBase | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomer(_response);
        });
    }

    protected processUpdateCustomer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getDirectory(projectId: string, id: string , cancelToken?: CancelToken | undefined): Promise<Directory360> {
        let url_ = this.baseUrl + "/api/v1/file/dir/{projectId}/{id}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDirectory(_response);
        });
    }

    protected processGetDirectory(response: AxiosResponse): Promise<Directory360> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Directory360.fromJS(resultData200);
            return Promise.resolve<Directory360>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Directory360>(null as any);
    }

    /**
     * @return Success
     */
    getFile(projectId: string, id: string , cancelToken?: CancelToken | undefined): Promise<File360> {
        let url_ = this.baseUrl + "/api/v1/file/{projectId}/{id}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: AxiosResponse): Promise<File360> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = File360.fromJS(resultData200);
            return Promise.resolve<File360>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<File360>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFiles(projectId: string, body?: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<File360[]> {
        let url_ = this.baseUrl + "/api/v1/file/batch/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFiles(_response);
        });
    }

    protected processGetFiles(response: AxiosResponse): Promise<File360[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(File360.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<File360[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<File360[]>(null as any);
    }

    /**
     * @param recursive (optional) 
     * @param fileExtensions (optional) 
     * @return Success
     */
    listFiles(projectId: string, directoryId: string, recursive?: boolean | undefined, fileExtensions?: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<ListFilesResult> {
        let url_ = this.baseUrl + "/api/v1/file/list/{projectId}/{directoryId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (directoryId === undefined || directoryId === null)
            throw new Error("The parameter 'directoryId' must be defined.");
        url_ = url_.replace("{directoryId}", encodeURIComponent("" + directoryId));
        if (recursive === null)
            throw new Error("The parameter 'recursive' cannot be null.");
        else if (recursive !== undefined)
            url_ += "recursive=" + encodeURIComponent("" + recursive) + "&";
        if (fileExtensions === null)
            throw new Error("The parameter 'fileExtensions' cannot be null.");
        else if (fileExtensions !== undefined)
            fileExtensions && fileExtensions.forEach(item => { url_ += "fileExtensions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFiles(_response);
        });
    }

    protected processListFiles(response: AxiosResponse): Promise<ListFilesResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListFilesResult.fromJS(resultData200);
            return Promise.resolve<ListFilesResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListFilesResult>(null as any);
    }

    /**
     * @return Success
     */
    listRecentFiles(  cancelToken?: CancelToken | undefined): Promise<JobFile[]> {
        let url_ = this.baseUrl + "/api/v1/file/recent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListRecentFiles(_response);
        });
    }

    protected processListRecentFiles(response: AxiosResponse): Promise<JobFile[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobFile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<JobFile[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobFile[]>(null as any);
    }

    /**
     * @param includeNonProjectFiles (optional) 
     * @return Success
     */
    listTopLevelDirectories(hubId: string, projectId: string, includeNonProjectFiles?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<Directory360[]> {
        let url_ = this.baseUrl + "/api/v1/file/top/{hubId}/{projectId}?";
        if (hubId === undefined || hubId === null)
            throw new Error("The parameter 'hubId' must be defined.");
        url_ = url_.replace("{hubId}", encodeURIComponent("" + hubId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (includeNonProjectFiles === null)
            throw new Error("The parameter 'includeNonProjectFiles' cannot be null.");
        else if (includeNonProjectFiles !== undefined)
            url_ += "includeNonProjectFiles=" + encodeURIComponent("" + includeNonProjectFiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListTopLevelDirectories(_response);
        });
    }

    protected processListTopLevelDirectories(response: AxiosResponse): Promise<Directory360[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Directory360.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Directory360[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Directory360[]>(null as any);
    }

    /**
     * @return Success
     */
    heartbeat(  cancelToken?: CancelToken | undefined): Promise<HealthStatus> {
        let url_ = this.baseUrl + "/api/v1/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHeartbeat(_response);
        });
    }

    protected processHeartbeat(response: AxiosResponse): Promise<HealthStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HealthStatus.fromJS(resultData200);
            return Promise.resolve<HealthStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HealthStatus>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createJob(body?: CreateJobRequestBase | undefined , cancelToken?: CancelToken | undefined): Promise<JobBase> {
        let url_ = this.baseUrl + "/api/v1/job";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJob(_response);
        });
    }

    protected processCreateJob(response: AxiosResponse): Promise<JobBase> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JobBase.fromJS(resultData201);
            return Promise.resolve<JobBase>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Client Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobBase>(null as any);
    }

    /**
     * @return Success
     */
    getJobs(  cancelToken?: CancelToken | undefined): Promise<JobBase[]> {
        let url_ = this.baseUrl + "/api/v1/job";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobs(_response);
        });
    }

    protected processGetJobs(response: AxiosResponse): Promise<JobBase[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<JobBase[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobBase[]>(null as any);
    }

    /**
     * @return No Content
     */
    deleteJob(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/job/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteJob(_response);
        });
    }

    protected processDeleteJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editJob(id: string, body?: EditJobRequestBase | undefined , cancelToken?: CancelToken | undefined): Promise<JobBase> {
        let url_ = this.baseUrl + "/api/v1/job/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditJob(_response);
        });
    }

    protected processEditJob(response: AxiosResponse): Promise<JobBase> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobBase.fromJS(resultData200);
            return Promise.resolve<JobBase>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Client Error", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobBase>(null as any);
    }

    /**
     * @return Success
     */
    getJob(id: string , cancelToken?: CancelToken | undefined): Promise<JobBase> {
        let url_ = this.baseUrl + "/api/v1/job/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJob(_response);
        });
    }

    protected processGetJob(response: AxiosResponse): Promise<JobBase> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobBase.fromJS(resultData200);
            return Promise.resolve<JobBase>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobBase>(null as any);
    }

    /**
     * @return Success
     */
    getJobRun(jobRunId: string , cancelToken?: CancelToken | undefined): Promise<JobRunBase> {
        let url_ = this.baseUrl + "/api/v1/job/status/{jobRunId}";
        if (jobRunId === undefined || jobRunId === null)
            throw new Error("The parameter 'jobRunId' must be defined.");
        url_ = url_.replace("{jobRunId}", encodeURIComponent("" + jobRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobRun(_response);
        });
    }

    protected processGetJobRun(response: AxiosResponse): Promise<JobRunBase> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobRunBase.fromJS(resultData200);
            return Promise.resolve<JobRunBase>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobRunBase>(null as any);
    }

    /**
     * @return Success
     */
    startJob(jobId: string , cancelToken?: CancelToken | undefined): Promise<JobRunBase> {
        let url_ = this.baseUrl + "/api/v1/job/start/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartJob(_response);
        });
    }

    protected processStartJob(response: AxiosResponse): Promise<JobRunBase> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobRunBase.fromJS(resultData200);
            return Promise.resolve<JobRunBase>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobRunBase>(null as any);
    }

    /**
     * @param includeLegacyHubs (optional) 
     * @return Success
     */
    listHubs(includeLegacyHubs?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<Hub[]> {
        let url_ = this.baseUrl + "/api/v1/project/hubs?";
        if (includeLegacyHubs === null)
            throw new Error("The parameter 'includeLegacyHubs' cannot be null.");
        else if (includeLegacyHubs !== undefined)
            url_ += "includeLegacyHubs=" + encodeURIComponent("" + includeLegacyHubs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListHubs(_response);
        });
    }

    protected processListHubs(response: AxiosResponse): Promise<Hub[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Hub.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Hub[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Hub[]>(null as any);
    }

    /**
     * @return Success
     */
    getProject(hubId: string, projectId: string , cancelToken?: CancelToken | undefined): Promise<Project> {
        let url_ = this.baseUrl + "/api/v1/project/{hubId}/{projectId}";
        if (hubId === undefined || hubId === null)
            throw new Error("The parameter 'hubId' must be defined.");
        url_ = url_.replace("{hubId}", encodeURIComponent("" + hubId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProject(_response);
        });
    }

    protected processGetProject(response: AxiosResponse): Promise<Project> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Project.fromJS(resultData200);
            return Promise.resolve<Project>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project>(null as any);
    }

    /**
     * @param includeLegacyHubs (optional) 
     * @return Success
     */
    listAll(includeLegacyHubs?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<Project[]> {
        let url_ = this.baseUrl + "/api/v1/project?";
        if (includeLegacyHubs === null)
            throw new Error("The parameter 'includeLegacyHubs' cannot be null.");
        else if (includeLegacyHubs !== undefined)
            url_ += "includeLegacyHubs=" + encodeURIComponent("" + includeLegacyHubs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAll(_response);
        });
    }

    protected processListAll(response: AxiosResponse): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Project.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Project[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project[]>(null as any);
    }

    /**
     * @param includeLegacyHubs (optional) 
     * @return Success
     */
    listImages(includeLegacyHubs?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<Project[]> {
        let url_ = this.baseUrl + "/api/v1/project/images?";
        if (includeLegacyHubs === null)
            throw new Error("The parameter 'includeLegacyHubs' cannot be null.");
        else if (includeLegacyHubs !== undefined)
            url_ += "includeLegacyHubs=" + encodeURIComponent("" + includeLegacyHubs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListImages(_response);
        });
    }

    protected processListImages(response: AxiosResponse): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Project.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Project[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project[]>(null as any);
    }

    /**
     * Gets the Revit version of a file from the Model Derivatives API.
     * @param userId (optional) The user ID.
     * @param projectId (optional) The project ID.
     * @param fileId (optional) The file ID.
     * @param region (optional) The region, optionally. Defaults to US.
     * @return Success
     */
    getRevitVersion(userId?: string | undefined, projectId?: string | undefined, fileId?: string | undefined, region?: string | undefined , cancelToken?: CancelToken | undefined): Promise<RvtVersionResponse> {
        let url_ = this.baseUrl + "/api/v1/test/rvtversion?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (region === null)
            throw new Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRevitVersion(_response);
        });
    }

    protected processGetRevitVersion(response: AxiosResponse): Promise<RvtVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RvtVersionResponse.fromJS(resultData200);
            return Promise.resolve<RvtVersionResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RvtVersionResponse>(null as any);
    }

    /**
     * Lists files and directories for the given project and query parameters.
     * @param projectId The project ID.
     * @param directoryId The directory ID from which to list files. To list files for the whole project, set this to
    the root directory ID, and leave recursive set to its default value of true.
     * @param recursive (optional) Whether to perform the search recursively, or only list files in the given folder. Defaults to
    true.
     * @param fileExtensions (optional) A collection of file extensions to filter for, optionally.
     * @param nameFilter (optional) File or folder name to filter for, optionally.
     * @return Success
     */
    listFilesTest(projectId: string, directoryId: string, recursive?: boolean | undefined, fileExtensions?: string[] | undefined, nameFilter?: string | undefined , cancelToken?: CancelToken | undefined): Promise<ListFilesResult> {
        let url_ = this.baseUrl + "/api/v1/test/list/{projectId}/{directoryId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (directoryId === undefined || directoryId === null)
            throw new Error("The parameter 'directoryId' must be defined.");
        url_ = url_.replace("{directoryId}", encodeURIComponent("" + directoryId));
        if (recursive === null)
            throw new Error("The parameter 'recursive' cannot be null.");
        else if (recursive !== undefined)
            url_ += "recursive=" + encodeURIComponent("" + recursive) + "&";
        if (fileExtensions === null)
            throw new Error("The parameter 'fileExtensions' cannot be null.");
        else if (fileExtensions !== undefined)
            fileExtensions && fileExtensions.forEach(item => { url_ += "fileExtensions=" + encodeURIComponent("" + item) + "&"; });
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "nameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFilesTest(_response);
        });
    }

    protected processListFilesTest(response: AxiosResponse): Promise<ListFilesResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListFilesResult.fromJS(resultData200);
            return Promise.resolve<ListFilesResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListFilesResult>(null as any);
    }

    /**
     * Uploads a file to Forge.
     * @param projectId (optional) The project ID.
     * @param directoryId (optional) The directory ID.
     * @param formFiles (optional) 
     * @return Accepted
     */
    uploadFile(projectId?: string | undefined, directoryId?: string | undefined, formFiles?: FileParameter[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/test/file?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (directoryId === null)
            throw new Error("The parameter 'directoryId' cannot be null.");
        else if (directoryId !== undefined)
            url_ += "directoryId=" + encodeURIComponent("" + directoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFiles === null || formFiles === undefined)
            throw new Error("The parameter 'formFiles' cannot be null.");
        else
            formFiles.forEach(item_ => content_.append("formFiles", item_.data, item_.fileName ? item_.fileName : "formFiles") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Uploads a file to S3.
     * @param bucket (optional) The project ID.
     * @param formFiles (optional) 
     * @return Accepted
     */
    uploadFileToAws(bucket?: string | undefined, formFiles?: FileParameter[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/test/s3?";
        if (bucket === null)
            throw new Error("The parameter 'bucket' cannot be null.");
        else if (bucket !== undefined)
            url_ += "bucket=" + encodeURIComponent("" + bucket) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFiles === null || formFiles === undefined)
            throw new Error("The parameter 'formFiles' cannot be null.");
        else
            formFiles.forEach(item_ => content_.append("formFiles", item_.data, item_.fileName ? item_.fileName : "formFiles") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFileToAws(_response);
        });
    }

    protected processUploadFileToAws(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param includeRuns (optional) 
     * @param limit (optional) 
     * @param paginationToken (optional) 
     * @param filter_CustomerIds (optional) 
     * @param filter_UserIds (optional) 
     * @param filter_JobIds (optional) 
     * @param filter_StartTime (optional) 
     * @param filter_EndTime (optional) 
     * @param sort_SortType (optional) 
     * @param sort_Ascending (optional) 
     * @return Success
     */
    getUsageSummary(includeRuns?: boolean | undefined, limit?: number | undefined, paginationToken?: string | undefined, filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | undefined, filter_EndTime?: Date | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<UsageSummaryBase> {
        let url_ = this.baseUrl + "/api/v1/usage/summary?";
        if (includeRuns === null)
            throw new Error("The parameter 'includeRuns' cannot be null.");
        else if (includeRuns !== undefined)
            url_ += "IncludeRuns=" + encodeURIComponent("" + includeRuns) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (paginationToken === null)
            throw new Error("The parameter 'paginationToken' cannot be null.");
        else if (paginationToken !== undefined)
            url_ += "PaginationToken=" + encodeURIComponent("" + paginationToken) + "&";
        if (filter_CustomerIds === null)
            throw new Error("The parameter 'filter_CustomerIds' cannot be null.");
        else if (filter_CustomerIds !== undefined)
            filter_CustomerIds && filter_CustomerIds.forEach(item => { url_ += "Filter.CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_UserIds === null)
            throw new Error("The parameter 'filter_UserIds' cannot be null.");
        else if (filter_UserIds !== undefined)
            filter_UserIds && filter_UserIds.forEach(item => { url_ += "Filter.UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_JobIds === null)
            throw new Error("The parameter 'filter_JobIds' cannot be null.");
        else if (filter_JobIds !== undefined)
            filter_JobIds && filter_JobIds.forEach(item => { url_ += "Filter.JobIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_StartTime === null)
            throw new Error("The parameter 'filter_StartTime' cannot be null.");
        else if (filter_StartTime !== undefined)
            url_ += "Filter.StartTime=" + encodeURIComponent(filter_StartTime ? "" + filter_StartTime.toISOString() : "") + "&";
        if (filter_EndTime === null)
            throw new Error("The parameter 'filter_EndTime' cannot be null.");
        else if (filter_EndTime !== undefined)
            url_ += "Filter.EndTime=" + encodeURIComponent(filter_EndTime ? "" + filter_EndTime.toISOString() : "") + "&";
        if (sort_SortType === null)
            throw new Error("The parameter 'sort_SortType' cannot be null.");
        else if (sort_SortType !== undefined)
            url_ += "Sort.SortType=" + encodeURIComponent("" + sort_SortType) + "&";
        if (sort_Ascending === null)
            throw new Error("The parameter 'sort_Ascending' cannot be null.");
        else if (sort_Ascending !== undefined)
            url_ += "Sort.Ascending=" + encodeURIComponent("" + sort_Ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsageSummary(_response);
        });
    }

    protected processGetUsageSummary(response: AxiosResponse): Promise<UsageSummaryBase> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UsageSummaryBase.fromJS(resultData200);
            return Promise.resolve<UsageSummaryBase>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UsageSummaryBase>(null as any);
    }

    /**
     * @param filter_CustomerIds (optional) 
     * @param filter_UserIds (optional) 
     * @param filter_JobIds (optional) 
     * @param filter_StartTime (optional) 
     * @param filter_EndTime (optional) 
     * @param sort_SortType (optional) 
     * @param sort_Ascending (optional) 
     * @return Success
     */
    startCsvDownload(filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | undefined, filter_EndTime?: Date | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<StartCsvDownloadResult> {
        let url_ = this.baseUrl + "/api/v1/usage/csv/start?";
        if (filter_CustomerIds === null)
            throw new Error("The parameter 'filter_CustomerIds' cannot be null.");
        else if (filter_CustomerIds !== undefined)
            filter_CustomerIds && filter_CustomerIds.forEach(item => { url_ += "Filter.CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_UserIds === null)
            throw new Error("The parameter 'filter_UserIds' cannot be null.");
        else if (filter_UserIds !== undefined)
            filter_UserIds && filter_UserIds.forEach(item => { url_ += "Filter.UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_JobIds === null)
            throw new Error("The parameter 'filter_JobIds' cannot be null.");
        else if (filter_JobIds !== undefined)
            filter_JobIds && filter_JobIds.forEach(item => { url_ += "Filter.JobIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_StartTime === null)
            throw new Error("The parameter 'filter_StartTime' cannot be null.");
        else if (filter_StartTime !== undefined)
            url_ += "Filter.StartTime=" + encodeURIComponent(filter_StartTime ? "" + filter_StartTime.toISOString() : "") + "&";
        if (filter_EndTime === null)
            throw new Error("The parameter 'filter_EndTime' cannot be null.");
        else if (filter_EndTime !== undefined)
            url_ += "Filter.EndTime=" + encodeURIComponent(filter_EndTime ? "" + filter_EndTime.toISOString() : "") + "&";
        if (sort_SortType === null)
            throw new Error("The parameter 'sort_SortType' cannot be null.");
        else if (sort_SortType !== undefined)
            url_ += "Sort.SortType=" + encodeURIComponent("" + sort_SortType) + "&";
        if (sort_Ascending === null)
            throw new Error("The parameter 'sort_Ascending' cannot be null.");
        else if (sort_Ascending !== undefined)
            url_ += "Sort.Ascending=" + encodeURIComponent("" + sort_Ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartCsvDownload(_response);
        });
    }

    protected processStartCsvDownload(response: AxiosResponse): Promise<StartCsvDownloadResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StartCsvDownloadResult.fromJS(resultData200);
            return Promise.resolve<StartCsvDownloadResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StartCsvDownloadResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCsvDownload(id?: string | undefined , cancelToken?: CancelToken | undefined): Promise<UsageDownloadDto> {
        let url_ = this.baseUrl + "/api/v1/usage/csv/status?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCsvDownload(_response);
        });
    }

    protected processGetCsvDownload(response: AxiosResponse): Promise<UsageDownloadDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UsageDownloadDto.fromJS(resultData200);
            return Promise.resolve<UsageDownloadDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UsageDownloadDto>(null as any);
    }

    /**
     * @param limit (optional) 
     * @param paginationToken (optional) 
     * @param filter_CustomerIds (optional) 
     * @param filter_UserIds (optional) 
     * @param filter_JobIds (optional) 
     * @param filter_StartTime (optional) 
     * @param filter_EndTime (optional) 
     * @param sort_SortType (optional) 
     * @param sort_Ascending (optional) 
     * @return Success
     */
    getDetailedUsage(limit?: number | undefined, paginationToken?: string | undefined, filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | undefined, filter_EndTime?: Date | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<DetailedUsageBase> {
        let url_ = this.baseUrl + "/api/v1/usage/detail?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (paginationToken === null)
            throw new Error("The parameter 'paginationToken' cannot be null.");
        else if (paginationToken !== undefined)
            url_ += "PaginationToken=" + encodeURIComponent("" + paginationToken) + "&";
        if (filter_CustomerIds === null)
            throw new Error("The parameter 'filter_CustomerIds' cannot be null.");
        else if (filter_CustomerIds !== undefined)
            filter_CustomerIds && filter_CustomerIds.forEach(item => { url_ += "Filter.CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_UserIds === null)
            throw new Error("The parameter 'filter_UserIds' cannot be null.");
        else if (filter_UserIds !== undefined)
            filter_UserIds && filter_UserIds.forEach(item => { url_ += "Filter.UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_JobIds === null)
            throw new Error("The parameter 'filter_JobIds' cannot be null.");
        else if (filter_JobIds !== undefined)
            filter_JobIds && filter_JobIds.forEach(item => { url_ += "Filter.JobIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_StartTime === null)
            throw new Error("The parameter 'filter_StartTime' cannot be null.");
        else if (filter_StartTime !== undefined)
            url_ += "Filter.StartTime=" + encodeURIComponent(filter_StartTime ? "" + filter_StartTime.toISOString() : "") + "&";
        if (filter_EndTime === null)
            throw new Error("The parameter 'filter_EndTime' cannot be null.");
        else if (filter_EndTime !== undefined)
            url_ += "Filter.EndTime=" + encodeURIComponent(filter_EndTime ? "" + filter_EndTime.toISOString() : "") + "&";
        if (sort_SortType === null)
            throw new Error("The parameter 'sort_SortType' cannot be null.");
        else if (sort_SortType !== undefined)
            url_ += "Sort.SortType=" + encodeURIComponent("" + sort_SortType) + "&";
        if (sort_Ascending === null)
            throw new Error("The parameter 'sort_Ascending' cannot be null.");
        else if (sort_Ascending !== undefined)
            url_ += "Sort.Ascending=" + encodeURIComponent("" + sort_Ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetailedUsage(_response);
        });
    }

    protected processGetDetailedUsage(response: AxiosResponse): Promise<DetailedUsageBase> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DetailedUsageBase.fromJS(resultData200);
            return Promise.resolve<DetailedUsageBase>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DetailedUsageBase>(null as any);
    }

    /**
     * @return Success
     */
    getUserAccounts(  cancelToken?: CancelToken | undefined): Promise<UserAccount[]> {
        let url_ = this.baseUrl + "/api/v1/user/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAccounts(_response);
        });
    }

    protected processGetUserAccounts(response: AxiosResponse): Promise<UserAccount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAccount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserAccount[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAccount[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserInfo(  cancelToken?: CancelToken | undefined): Promise<UserBase> {
        let url_ = this.baseUrl + "/api/v1/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: AxiosResponse): Promise<UserBase> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserBase.fromJS(resultData200);
            return Promise.resolve<UserBase>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserBase>(null as any);
    }

    /**
     * @param x_adsk_signature (optional) 
     * @param body (optional) 
     * @return Success
     */
    userWebhookCallback(x_adsk_signature?: string | undefined, body?: GDPRWebhook | undefined , cancelToken?: CancelToken | undefined): Promise<GDPRWebhookResponse> {
        let url_ = this.baseUrl + "/api/v1/user/gdprcallback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-adsk-signature": x_adsk_signature !== undefined && x_adsk_signature !== null ? "" + x_adsk_signature : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserWebhookCallback(_response);
        });
    }

    protected processUserWebhookCallback(response: AxiosResponse): Promise<GDPRWebhookResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GDPRWebhookResponse.fromJS(resultData200);
            return Promise.resolve<GDPRWebhookResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GDPRWebhookResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createWebhook(body?: CreateWebhookRequest | undefined , cancelToken?: CancelToken | undefined): Promise<Webhook> {
        let url_ = this.baseUrl + "/api/v1/webhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWebhook(_response);
        });
    }

    protected processCreateWebhook(response: AxiosResponse): Promise<Webhook> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = Webhook.fromJS(resultData201);
            return Promise.resolve<Webhook>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Webhook>(null as any);
    }

    /**
     * @param eventType (optional) 
     * @param folderId (optional) 
     * @param region (optional) 
     * @param system (optional) 
     * @return Success
     */
    listWebhooks(eventType?: WebhookEvent | undefined, folderId?: string | undefined, region?: string | undefined, system?: string | undefined , cancelToken?: CancelToken | undefined): Promise<Webhook[]> {
        let url_ = this.baseUrl + "/api/v1/webhook?";
        if (eventType === null)
            throw new Error("The parameter 'eventType' cannot be null.");
        else if (eventType !== undefined)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        if (folderId === null)
            throw new Error("The parameter 'folderId' cannot be null.");
        else if (folderId !== undefined)
            url_ += "folderId=" + encodeURIComponent("" + folderId) + "&";
        if (region === null)
            throw new Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (system === null)
            throw new Error("The parameter 'system' cannot be null.");
        else if (system !== undefined)
            url_ += "system=" + encodeURIComponent("" + system) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListWebhooks(_response);
        });
    }

    protected processListWebhooks(response: AxiosResponse): Promise<Webhook[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Webhook.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Webhook[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Webhook[]>(null as any);
    }

    /**
     * @return No Content
     */
    deleteUserWebhooks(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/webhook/batch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserWebhooks(_response);
        });
    }

    protected processDeleteUserWebhooks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteUserWebhooksAdmin(userId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/webhook/admin/batch/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserWebhooksAdmin(_response);
        });
    }

    protected processDeleteUserWebhooksAdmin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteWebhook(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/webhook/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWebhook(_response);
        });
    }

    protected processDeleteWebhook(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getWebhook(id: string , cancelToken?: CancelToken | undefined): Promise<Webhook> {
        let url_ = this.baseUrl + "/api/v1/webhook/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWebhook(_response);
        });
    }

    protected processGetWebhook(response: AxiosResponse): Promise<Webhook> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Webhook.fromJS(resultData200);
            return Promise.resolve<Webhook>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Webhook>(null as any);
    }

    /**
     * @return No Content
     */
    deleteWebhookAdmin(userId: string, id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/webhook/admin/{userId}/{id}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWebhookAdmin(_response);
        });
    }

    protected processDeleteWebhookAdmin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param eventType (optional) 
     * @param folderId (optional) 
     * @param region (optional) 
     * @param system (optional) 
     * @return Success
     */
    listWebhooksAdmin(userId: string, eventType?: WebhookEvent | undefined, folderId?: string | undefined, region?: string | undefined, system?: string | undefined , cancelToken?: CancelToken | undefined): Promise<Webhook[]> {
        let url_ = this.baseUrl + "/api/v1/webhook/admin/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (eventType === null)
            throw new Error("The parameter 'eventType' cannot be null.");
        else if (eventType !== undefined)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        if (folderId === null)
            throw new Error("The parameter 'folderId' cannot be null.");
        else if (folderId !== undefined)
            url_ += "folderId=" + encodeURIComponent("" + folderId) + "&";
        if (region === null)
            throw new Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (system === null)
            throw new Error("The parameter 'system' cannot be null.");
        else if (system !== undefined)
            url_ += "system=" + encodeURIComponent("" + system) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListWebhooksAdmin(_response);
        });
    }

    protected processListWebhooksAdmin(response: AxiosResponse): Promise<Webhook[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Webhook.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Webhook[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Webhook[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    webhookCallback(body?: WebhookBody | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/webhook/callback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWebhookCallback(_response);
        });
    }

    protected processWebhookCallback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Ancestor implements IAncestor {
    urn?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAncestor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urn = _data["urn"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Ancestor {
        data = typeof data === 'object' ? data : {};
        let result = new Ancestor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urn"] = this.urn;
        data["name"] = this.name;
        return data;
    }
}

export interface IAncestor {
    urn?: string | undefined;
    name?: string | undefined;
}

export class CoreAuthData implements ICoreAuthData {
    readonly userId?: string | undefined;
    readonly user?: CustomerUser | undefined;
    readonly authTokenExpiry?: Date;
    readonly adskAccessToken?: string | undefined;
    readonly refreshToken?: string | undefined;
    readonly refreshTokenExpiry?: Date;
    readonly scope?: string | undefined;
    authToken?: string | undefined;

    constructor(data?: ICoreAuthData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).userId = _data["userId"];
            (<any>this).user = _data["user"] ? CustomerUser.fromJS(_data["user"]) : <any>undefined;
            (<any>this).authTokenExpiry = _data["authTokenExpiry"] ? new Date(_data["authTokenExpiry"].toString()) : <any>undefined;
            (<any>this).adskAccessToken = _data["adskAccessToken"];
            (<any>this).refreshToken = _data["refreshToken"];
            (<any>this).refreshTokenExpiry = _data["refreshTokenExpiry"] ? new Date(_data["refreshTokenExpiry"].toString()) : <any>undefined;
            (<any>this).scope = _data["scope"];
            this.authToken = _data["authToken"];
        }
    }

    static fromJS(data: any): CoreAuthData {
        data = typeof data === 'object' ? data : {};
        let result = new CoreAuthData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["authTokenExpiry"] = this.authTokenExpiry ? this.authTokenExpiry.toISOString() : <any>undefined;
        data["adskAccessToken"] = this.adskAccessToken;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiry"] = this.refreshTokenExpiry ? this.refreshTokenExpiry.toISOString() : <any>undefined;
        data["scope"] = this.scope;
        data["authToken"] = this.authToken;
        return data;
    }
}

export interface ICoreAuthData {
    userId?: string | undefined;
    user?: CustomerUser | undefined;
    authTokenExpiry?: Date;
    adskAccessToken?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpiry?: Date;
    scope?: string | undefined;
    authToken?: string | undefined;
}

export class CreateCustomerRequestBase implements ICreateCustomerRequestBase {
    emailDomain?: string | undefined;
    name?: string | undefined;
    validEmails?: string[] | undefined;
    allowAllUsers?: boolean;

    constructor(data?: ICreateCustomerRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailDomain = _data["emailDomain"];
            this.name = _data["name"];
            if (Array.isArray(_data["validEmails"])) {
                this.validEmails = [] as any;
                for (let item of _data["validEmails"])
                    this.validEmails!.push(item);
            }
            this.allowAllUsers = _data["allowAllUsers"];
        }
    }

    static fromJS(data: any): CreateCustomerRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailDomain"] = this.emailDomain;
        data["name"] = this.name;
        if (Array.isArray(this.validEmails)) {
            data["validEmails"] = [];
            for (let item of this.validEmails)
                data["validEmails"].push(item);
        }
        data["allowAllUsers"] = this.allowAllUsers;
        return data;
    }
}

export interface ICreateCustomerRequestBase {
    emailDomain?: string | undefined;
    name?: string | undefined;
    validEmails?: string[] | undefined;
    allowAllUsers?: boolean;
}

export class CreateJobRequestBase implements ICreateJobRequestBase {
    name?: string | undefined;
    models?: FileDto[] | undefined;
    directories?: DirectoryDto[] | undefined;
    jobScheduleType?: JobScheduleType;
    schedule?: Schedule | undefined;
    runOnceDateTime?: Date | undefined;
    paused?: boolean;

    constructor(data?: ICreateJobRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(FileDto.fromJS(item));
            }
            if (Array.isArray(_data["directories"])) {
                this.directories = [] as any;
                for (let item of _data["directories"])
                    this.directories!.push(DirectoryDto.fromJS(item));
            }
            this.jobScheduleType = _data["jobScheduleType"];
            this.schedule = _data["schedule"] ? Schedule.fromJS(_data["schedule"]) : <any>undefined;
            this.runOnceDateTime = _data["runOnceDateTime"] ? new Date(_data["runOnceDateTime"].toString()) : <any>undefined;
            this.paused = _data["paused"];
        }
    }

    static fromJS(data: any): CreateJobRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item.toJSON());
        }
        if (Array.isArray(this.directories)) {
            data["directories"] = [];
            for (let item of this.directories)
                data["directories"].push(item.toJSON());
        }
        data["jobScheduleType"] = this.jobScheduleType;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        data["runOnceDateTime"] = this.runOnceDateTime ? this.runOnceDateTime.toISOString() : <any>undefined;
        data["paused"] = this.paused;
        return data;
    }
}

export interface ICreateJobRequestBase {
    name?: string | undefined;
    models?: FileDto[] | undefined;
    directories?: DirectoryDto[] | undefined;
    jobScheduleType?: JobScheduleType;
    schedule?: Schedule | undefined;
    runOnceDateTime?: Date | undefined;
    paused?: boolean;
}

export class CreateWebhookRequest implements ICreateWebhookRequest {
    directory?: DirectoryDto | undefined;
    webhookEventType?: WebhookEvent;

    constructor(data?: ICreateWebhookRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.directory = _data["directory"] ? DirectoryDto.fromJS(_data["directory"]) : <any>undefined;
            this.webhookEventType = _data["webhookEventType"];
        }
    }

    static fromJS(data: any): CreateWebhookRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWebhookRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["directory"] = this.directory ? this.directory.toJSON() : <any>undefined;
        data["webhookEventType"] = this.webhookEventType;
        return data;
    }
}

export interface ICreateWebhookRequest {
    directory?: DirectoryDto | undefined;
    webhookEventType?: WebhookEvent;
}

export class CustomerInfo implements ICustomerInfo {
    id?: string | undefined;
    name?: string | undefined;
    readonly emailDomain?: string | undefined;
    validEmails?: string[] | undefined;
    allowAllUsers?: boolean;

    constructor(data?: ICustomerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            (<any>this).emailDomain = _data["emailDomain"];
            if (Array.isArray(_data["validEmails"])) {
                this.validEmails = [] as any;
                for (let item of _data["validEmails"])
                    this.validEmails!.push(item);
            }
            this.allowAllUsers = _data["allowAllUsers"];
        }
    }

    static fromJS(data: any): CustomerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["emailDomain"] = this.emailDomain;
        if (Array.isArray(this.validEmails)) {
            data["validEmails"] = [];
            for (let item of this.validEmails)
                data["validEmails"].push(item);
        }
        data["allowAllUsers"] = this.allowAllUsers;
        return data;
    }
}

export interface ICustomerInfo {
    id?: string | undefined;
    name?: string | undefined;
    emailDomain?: string | undefined;
    validEmails?: string[] | undefined;
    allowAllUsers?: boolean;
}

export class CustomerUsageDataBase implements ICustomerUsageDataBase {
    customerId?: string | undefined;
    customerName?: string | undefined;
    readonly jobRunCount?: number;
    readonly level?: UsageDataLevel;
    readonly runTimeSeconds?: number;
    userUsageDatas?: UserUsageDataBase[] | undefined;

    constructor(data?: ICustomerUsageDataBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            (<any>this).jobRunCount = _data["jobRunCount"];
            (<any>this).level = _data["level"];
            (<any>this).runTimeSeconds = _data["runTimeSeconds"];
            if (Array.isArray(_data["userUsageDatas"])) {
                this.userUsageDatas = [] as any;
                for (let item of _data["userUsageDatas"])
                    this.userUsageDatas!.push(UserUsageDataBase.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerUsageDataBase {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUsageDataBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["jobRunCount"] = this.jobRunCount;
        data["level"] = this.level;
        data["runTimeSeconds"] = this.runTimeSeconds;
        if (Array.isArray(this.userUsageDatas)) {
            data["userUsageDatas"] = [];
            for (let item of this.userUsageDatas)
                data["userUsageDatas"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerUsageDataBase {
    customerId?: string | undefined;
    customerName?: string | undefined;
    jobRunCount?: number;
    level?: UsageDataLevel;
    runTimeSeconds?: number;
    userUsageDatas?: UserUsageDataBase[] | undefined;
}

export class CustomerUser implements ICustomerUser {
    id?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isEmailVerified?: boolean;
    is2FAEnabled?: boolean;
    language?: string | undefined;
    countryCode?: string | undefined;
    profileImages?: UserProfileImages | undefined;
    customer?: CustomerInfo | undefined;
    readonly isAdmin?: boolean;
    roles?: string[] | undefined;

    constructor(data?: ICustomerUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isEmailVerified = _data["isEmailVerified"];
            this.is2FAEnabled = _data["is2FAEnabled"];
            this.language = _data["language"];
            this.countryCode = _data["countryCode"];
            this.profileImages = _data["profileImages"] ? UserProfileImages.fromJS(_data["profileImages"]) : <any>undefined;
            this.customer = _data["customer"] ? CustomerInfo.fromJS(_data["customer"]) : <any>undefined;
            (<any>this).isAdmin = _data["isAdmin"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CustomerUser {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isEmailVerified"] = this.isEmailVerified;
        data["is2FAEnabled"] = this.is2FAEnabled;
        data["language"] = this.language;
        data["countryCode"] = this.countryCode;
        data["profileImages"] = this.profileImages ? this.profileImages.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["isAdmin"] = this.isAdmin;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ICustomerUser {
    id?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isEmailVerified?: boolean;
    is2FAEnabled?: boolean;
    language?: string | undefined;
    countryCode?: string | undefined;
    profileImages?: UserProfileImages | undefined;
    customer?: CustomerInfo | undefined;
    isAdmin?: boolean;
    roles?: string[] | undefined;
}

export class DetailedUsageBase implements IDetailedUsageBase {
    paginationDataDictionary?: { [key: string]: PaginationData; } | undefined;
    readonly paginationData?: PaginationData | undefined;
    readonly paginationToken?: string | undefined;
    isDoneDictionary?: { [key: string]: boolean; } | undefined;
    readonly isDone?: boolean;
    entries?: JobDataEntry[] | undefined;

    constructor(data?: IDetailedUsageBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["paginationDataDictionary"]) {
                this.paginationDataDictionary = {} as any;
                for (let key in _data["paginationDataDictionary"]) {
                    if (_data["paginationDataDictionary"].hasOwnProperty(key))
                        (<any>this.paginationDataDictionary)![key] = _data["paginationDataDictionary"][key] ? PaginationData.fromJS(_data["paginationDataDictionary"][key]) : new PaginationData();
                }
            }
            (<any>this).paginationData = _data["paginationData"] ? PaginationData.fromJS(_data["paginationData"]) : <any>undefined;
            (<any>this).paginationToken = _data["paginationToken"];
            if (_data["isDoneDictionary"]) {
                this.isDoneDictionary = {} as any;
                for (let key in _data["isDoneDictionary"]) {
                    if (_data["isDoneDictionary"].hasOwnProperty(key))
                        (<any>this.isDoneDictionary)![key] = _data["isDoneDictionary"][key];
                }
            }
            (<any>this).isDone = _data["isDone"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(JobDataEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DetailedUsageBase {
        data = typeof data === 'object' ? data : {};
        let result = new DetailedUsageBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paginationDataDictionary) {
            data["paginationDataDictionary"] = {};
            for (let key in this.paginationDataDictionary) {
                if (this.paginationDataDictionary.hasOwnProperty(key))
                    (<any>data["paginationDataDictionary"])[key] = this.paginationDataDictionary[key] ? this.paginationDataDictionary[key].toJSON() : <any>undefined;
            }
        }
        data["paginationData"] = this.paginationData ? this.paginationData.toJSON() : <any>undefined;
        data["paginationToken"] = this.paginationToken;
        if (this.isDoneDictionary) {
            data["isDoneDictionary"] = {};
            for (let key in this.isDoneDictionary) {
                if (this.isDoneDictionary.hasOwnProperty(key))
                    (<any>data["isDoneDictionary"])[key] = (<any>this.isDoneDictionary)[key];
            }
        }
        data["isDone"] = this.isDone;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDetailedUsageBase {
    paginationDataDictionary?: { [key: string]: PaginationData; } | undefined;
    paginationData?: PaginationData | undefined;
    paginationToken?: string | undefined;
    isDoneDictionary?: { [key: string]: boolean; } | undefined;
    isDone?: boolean;
    entries?: JobDataEntry[] | undefined;
}

export class Directory360 implements IDirectory360 {
    readonly id?: string | undefined;
    readonly name?: string | undefined;
    readonly displayName?: string | undefined;
    readonly parentId?: string | undefined;
    readonly projectId?: string | undefined;
    readonly lastUpdated?: Date;
    readonly lastUpdatedBy?: string | undefined;
    readonly isHidden?: boolean;
    readonly isDirectory?: boolean;
    visibleTypes?: string[] | undefined;

    constructor(data?: IDirectory360) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
            (<any>this).displayName = _data["displayName"];
            (<any>this).parentId = _data["parentId"];
            (<any>this).projectId = _data["projectId"];
            (<any>this).lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            (<any>this).lastUpdatedBy = _data["lastUpdatedBy"];
            (<any>this).isHidden = _data["isHidden"];
            (<any>this).isDirectory = _data["isDirectory"];
            if (Array.isArray(_data["visibleTypes"])) {
                this.visibleTypes = [] as any;
                for (let item of _data["visibleTypes"])
                    this.visibleTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): Directory360 {
        data = typeof data === 'object' ? data : {};
        let result = new Directory360();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        data["projectId"] = this.projectId;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["isHidden"] = this.isHidden;
        data["isDirectory"] = this.isDirectory;
        if (Array.isArray(this.visibleTypes)) {
            data["visibleTypes"] = [];
            for (let item of this.visibleTypes)
                data["visibleTypes"].push(item);
        }
        return data;
    }
}

export interface IDirectory360 {
    id?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    parentId?: string | undefined;
    projectId?: string | undefined;
    lastUpdated?: Date;
    lastUpdatedBy?: string | undefined;
    isHidden?: boolean;
    isDirectory?: boolean;
    visibleTypes?: string[] | undefined;
}

export class DirectoryDto implements IDirectoryDto {
    id?: string | undefined;
    projectId?: string | undefined;
    hubId?: string | undefined;
    recursive?: boolean;

    constructor(data?: IDirectoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.hubId = _data["hubId"];
            this.recursive = _data["recursive"];
        }
    }

    static fromJS(data: any): DirectoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["hubId"] = this.hubId;
        data["recursive"] = this.recursive;
        return data;
    }
}

export interface IDirectoryDto {
    id?: string | undefined;
    projectId?: string | undefined;
    hubId?: string | undefined;
    recursive?: boolean;
}

export class EditCustomerRequestBase implements IEditCustomerRequestBase {
    name?: string | undefined;
    addValidEmails?: string[] | undefined;
    removeValidEmails?: string[] | undefined;
    allowAllUsers?: boolean | undefined;

    constructor(data?: IEditCustomerRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["addValidEmails"])) {
                this.addValidEmails = [] as any;
                for (let item of _data["addValidEmails"])
                    this.addValidEmails!.push(item);
            }
            if (Array.isArray(_data["removeValidEmails"])) {
                this.removeValidEmails = [] as any;
                for (let item of _data["removeValidEmails"])
                    this.removeValidEmails!.push(item);
            }
            this.allowAllUsers = _data["allowAllUsers"];
        }
    }

    static fromJS(data: any): EditCustomerRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new EditCustomerRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.addValidEmails)) {
            data["addValidEmails"] = [];
            for (let item of this.addValidEmails)
                data["addValidEmails"].push(item);
        }
        if (Array.isArray(this.removeValidEmails)) {
            data["removeValidEmails"] = [];
            for (let item of this.removeValidEmails)
                data["removeValidEmails"].push(item);
        }
        data["allowAllUsers"] = this.allowAllUsers;
        return data;
    }
}

export interface IEditCustomerRequestBase {
    name?: string | undefined;
    addValidEmails?: string[] | undefined;
    removeValidEmails?: string[] | undefined;
    allowAllUsers?: boolean | undefined;
}

export class EditJobRequestBase implements IEditJobRequestBase {
    name?: string | undefined;
    jobScheduleType?: JobScheduleType | undefined;
    editSchedule?: EditScheduleRequest | undefined;
    runOnceDateTime?: Date | undefined;
    pauseJob?: boolean | undefined;

    constructor(data?: IEditJobRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.jobScheduleType = _data["jobScheduleType"];
            this.editSchedule = _data["editSchedule"] ? EditScheduleRequest.fromJS(_data["editSchedule"]) : <any>undefined;
            this.runOnceDateTime = _data["runOnceDateTime"] ? new Date(_data["runOnceDateTime"].toString()) : <any>undefined;
            this.pauseJob = _data["pauseJob"];
        }
    }

    static fromJS(data: any): EditJobRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new EditJobRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["jobScheduleType"] = this.jobScheduleType;
        data["editSchedule"] = this.editSchedule ? this.editSchedule.toJSON() : <any>undefined;
        data["runOnceDateTime"] = this.runOnceDateTime ? this.runOnceDateTime.toISOString() : <any>undefined;
        data["pauseJob"] = this.pauseJob;
        return data;
    }
}

export interface IEditJobRequestBase {
    name?: string | undefined;
    jobScheduleType?: JobScheduleType | undefined;
    editSchedule?: EditScheduleRequest | undefined;
    runOnceDateTime?: Date | undefined;
    pauseJob?: boolean | undefined;
}

export class EditScheduleRequest implements IEditScheduleRequest {
    cronString?: string | undefined;
    startDate?: Date | undefined;
    clearStartDate?: boolean;
    endDate?: Date | undefined;
    clearEndDate?: boolean;
    maxRuns?: number | undefined;

    constructor(data?: IEditScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cronString = _data["cronString"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.clearStartDate = _data["clearStartDate"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.clearEndDate = _data["clearEndDate"];
            this.maxRuns = _data["maxRuns"];
        }
    }

    static fromJS(data: any): EditScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cronString"] = this.cronString;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["clearStartDate"] = this.clearStartDate;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["clearEndDate"] = this.clearEndDate;
        data["maxRuns"] = this.maxRuns;
        return data;
    }
}

export interface IEditScheduleRequest {
    cronString?: string | undefined;
    startDate?: Date | undefined;
    clearStartDate?: boolean;
    endDate?: Date | undefined;
    clearEndDate?: boolean;
    maxRuns?: number | undefined;
}

export class File360 implements IFile360 {
    readonly id?: string | undefined;
    readonly name?: string | undefined;
    readonly displayName?: string | undefined;
    readonly parentId?: string | undefined;
    readonly projectId?: string | undefined;
    readonly lastUpdated?: Date;
    readonly lastUpdatedBy?: string | undefined;
    readonly isHidden?: boolean;
    directoryId?: string | undefined;
    fileType?: FileType | undefined;
    thumbnail?: string | undefined;
    readonly isDirectory?: boolean;
    versionNumber?: number;
    objectId?: string | undefined;
    isComposite?: boolean;
    size?: number;
    isLocked?: boolean;
    pathInProject?: string | undefined;
    derivativesId?: string | undefined;
    isProcessed?: boolean;
    compositeParentFile?: string | undefined;
    readonly fileNameWithExtension?: string | undefined;

    constructor(data?: IFile360) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
            (<any>this).displayName = _data["displayName"];
            (<any>this).parentId = _data["parentId"];
            (<any>this).projectId = _data["projectId"];
            (<any>this).lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            (<any>this).lastUpdatedBy = _data["lastUpdatedBy"];
            (<any>this).isHidden = _data["isHidden"];
            this.directoryId = _data["directoryId"];
            this.fileType = _data["fileType"] ? FileType.fromJS(_data["fileType"]) : <any>undefined;
            this.thumbnail = _data["thumbnail"];
            (<any>this).isDirectory = _data["isDirectory"];
            this.versionNumber = _data["versionNumber"];
            this.objectId = _data["objectId"];
            this.isComposite = _data["isComposite"];
            this.size = _data["size"];
            this.isLocked = _data["isLocked"];
            this.pathInProject = _data["pathInProject"];
            this.derivativesId = _data["derivativesId"];
            this.isProcessed = _data["isProcessed"];
            this.compositeParentFile = _data["compositeParentFile"];
            (<any>this).fileNameWithExtension = _data["fileNameWithExtension"];
        }
    }

    static fromJS(data: any): File360 {
        data = typeof data === 'object' ? data : {};
        let result = new File360();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        data["projectId"] = this.projectId;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["isHidden"] = this.isHidden;
        data["directoryId"] = this.directoryId;
        data["fileType"] = this.fileType ? this.fileType.toJSON() : <any>undefined;
        data["thumbnail"] = this.thumbnail;
        data["isDirectory"] = this.isDirectory;
        data["versionNumber"] = this.versionNumber;
        data["objectId"] = this.objectId;
        data["isComposite"] = this.isComposite;
        data["size"] = this.size;
        data["isLocked"] = this.isLocked;
        data["pathInProject"] = this.pathInProject;
        data["derivativesId"] = this.derivativesId;
        data["isProcessed"] = this.isProcessed;
        data["compositeParentFile"] = this.compositeParentFile;
        data["fileNameWithExtension"] = this.fileNameWithExtension;
        return data;
    }
}

export interface IFile360 {
    id?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    parentId?: string | undefined;
    projectId?: string | undefined;
    lastUpdated?: Date;
    lastUpdatedBy?: string | undefined;
    isHidden?: boolean;
    directoryId?: string | undefined;
    fileType?: FileType | undefined;
    thumbnail?: string | undefined;
    isDirectory?: boolean;
    versionNumber?: number;
    objectId?: string | undefined;
    isComposite?: boolean;
    size?: number;
    isLocked?: boolean;
    pathInProject?: string | undefined;
    derivativesId?: string | undefined;
    isProcessed?: boolean;
    compositeParentFile?: string | undefined;
    fileNameWithExtension?: string | undefined;
}

export class FileDto implements IFileDto {
    id?: string | undefined;
    projectId?: string | undefined;
    hubId?: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.hubId = _data["hubId"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["hubId"] = this.hubId;
        return data;
    }
}

export interface IFileDto {
    id?: string | undefined;
    projectId?: string | undefined;
    hubId?: string | undefined;
}

export class FileType implements IFileType {
    readonly displayText?: string | undefined;
    readonly fileDescription?: string | undefined;
    fileExtension?: string | undefined;

    constructor(data?: IFileType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).displayText = _data["displayText"];
            (<any>this).fileDescription = _data["fileDescription"];
            this.fileExtension = _data["fileExtension"];
        }
    }

    static fromJS(data: any): FileType {
        data = typeof data === 'object' ? data : {};
        let result = new FileType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayText"] = this.displayText;
        data["fileDescription"] = this.fileDescription;
        data["fileExtension"] = this.fileExtension;
        return data;
    }
}

export interface IFileType {
    displayText?: string | undefined;
    fileDescription?: string | undefined;
    fileExtension?: string | undefined;
}

export class ForgePageData implements IForgePageData {
    paginationToken?: number | undefined;
    limit?: number | undefined;

    constructor(data?: IForgePageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paginationToken = _data["paginationToken"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): ForgePageData {
        data = typeof data === 'object' ? data : {};
        let result = new ForgePageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paginationToken"] = this.paginationToken;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IForgePageData {
    paginationToken?: number | undefined;
    limit?: number | undefined;
}

export class GDPRHook implements IGDPRHook {
    eventType?: string | undefined;
    hookId?: string | undefined;
    clientID?: string | undefined;
    webhookEndPoint?: string | undefined;
    createdDate?: string | undefined;

    constructor(data?: IGDPRHook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.hookId = _data["hookId"];
            this.clientID = _data["clientID"];
            this.webhookEndPoint = _data["webhookEndPoint"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): GDPRHook {
        data = typeof data === 'object' ? data : {};
        let result = new GDPRHook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["hookId"] = this.hookId;
        data["clientID"] = this.clientID;
        data["webhookEndPoint"] = this.webhookEndPoint;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IGDPRHook {
    eventType?: string | undefined;
    hookId?: string | undefined;
    clientID?: string | undefined;
    webhookEndPoint?: string | undefined;
    createdDate?: string | undefined;
}

export class GDPRWebhook implements IGDPRWebhook {
    version?: number | undefined;
    hook?: GDPRHook | undefined;
    payload?: GDPRWebhookPayload | undefined;

    constructor(data?: IGDPRWebhook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.hook = _data["hook"] ? GDPRHook.fromJS(_data["hook"]) : <any>undefined;
            this.payload = _data["payload"] ? GDPRWebhookPayload.fromJS(_data["payload"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GDPRWebhook {
        data = typeof data === 'object' ? data : {};
        let result = new GDPRWebhook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["hook"] = this.hook ? this.hook.toJSON() : <any>undefined;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGDPRWebhook {
    version?: number | undefined;
    hook?: GDPRHook | undefined;
    payload?: GDPRWebhookPayload | undefined;
}

export class GDPRWebhookPayload implements IGDPRWebhookPayload {
    version?: number | undefined;
    taskId?: string | undefined;
    user_info?: GDPRWebhookUserInfo | undefined;
    callbackUrl?: string | undefined;
    respondBy?: number | undefined;
    status?: string | undefined;

    constructor(data?: IGDPRWebhookPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.taskId = _data["taskId"];
            this.user_info = _data["user_info"] ? GDPRWebhookUserInfo.fromJS(_data["user_info"]) : <any>undefined;
            this.callbackUrl = _data["callbackUrl"];
            this.respondBy = _data["respondBy"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GDPRWebhookPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GDPRWebhookPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["taskId"] = this.taskId;
        data["user_info"] = this.user_info ? this.user_info.toJSON() : <any>undefined;
        data["callbackUrl"] = this.callbackUrl;
        data["respondBy"] = this.respondBy;
        data["status"] = this.status;
        return data;
    }
}

export interface IGDPRWebhookPayload {
    version?: number | undefined;
    taskId?: string | undefined;
    user_info?: GDPRWebhookUserInfo | undefined;
    callbackUrl?: string | undefined;
    respondBy?: number | undefined;
    status?: string | undefined;
}

export class GDPRWebhookResponse implements IGDPRWebhookResponse {
    taskId?: string | undefined;
    status?: GDPRWebhookResponseStatus | undefined;
    description?: string | undefined;

    constructor(data?: IGDPRWebhookResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.status = _data["status"] ? GDPRWebhookResponseStatus.fromJS(_data["status"]) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GDPRWebhookResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GDPRWebhookResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface IGDPRWebhookResponse {
    taskId?: string | undefined;
    status?: GDPRWebhookResponseStatus | undefined;
    description?: string | undefined;
}

export class GDPRWebhookResponseStatus implements IGDPRWebhookResponseStatus {
    code?: string | undefined;
    type?: string | undefined;
    userType?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IGDPRWebhookResponseStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.userType = _data["userType"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): GDPRWebhookResponseStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GDPRWebhookResponseStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["userType"] = this.userType;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IGDPRWebhookResponseStatus {
    code?: string | undefined;
    type?: string | undefined;
    userType?: string | undefined;
    reason?: string | undefined;
}

export class GDPRWebhookUserInfo implements IGDPRWebhookUserInfo {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    user_type?: string | undefined;

    constructor(data?: IGDPRWebhookUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.user_type = _data["user_type"];
        }
    }

    static fromJS(data: any): GDPRWebhookUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new GDPRWebhookUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["user_type"] = this.user_type;
        return data;
    }
}

export interface IGDPRWebhookUserInfo {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    user_type?: string | undefined;
}

export class HealthStatus implements IHealthStatus {
    readonly assemblyVersion?: string | undefined;
    readonly fileVersion?: string | undefined;
    readonly productVersion?: string | undefined;
    readonly buildDateTime?: Date;
    readonly requestDate?: Date;

    constructor(data?: IHealthStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).assemblyVersion = _data["assemblyVersion"];
            (<any>this).fileVersion = _data["fileVersion"];
            (<any>this).productVersion = _data["productVersion"];
            (<any>this).buildDateTime = _data["buildDateTime"] ? new Date(_data["buildDateTime"].toString()) : <any>undefined;
            (<any>this).requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthStatus {
        data = typeof data === 'object' ? data : {};
        let result = new HealthStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assemblyVersion"] = this.assemblyVersion;
        data["fileVersion"] = this.fileVersion;
        data["productVersion"] = this.productVersion;
        data["buildDateTime"] = this.buildDateTime ? this.buildDateTime.toISOString() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHealthStatus {
    assemblyVersion?: string | undefined;
    fileVersion?: string | undefined;
    productVersion?: string | undefined;
    buildDateTime?: Date;
    requestDate?: Date;
}

export class Hook implements IHook {
    hookId?: string | undefined;
    tenant?: string | undefined;
    callbackUrl?: string | undefined;
    createdBy?: string | undefined;
    event?: string | undefined;
    createdDate?: Date;
    system?: string | undefined;
    creatorType?: string | undefined;
    status?: string | undefined;
    scope?: Scope | undefined;
    urn?: string | undefined;
    filter?: string | undefined;
    projectId?: string | undefined;
    hubId?: string | undefined;
    autoReactivateHook?: boolean;
    hookAttribute?: { [key: string]: any; } | undefined;
    __self__?: string | undefined;

    constructor(data?: IHook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hookId = _data["hookId"];
            this.tenant = _data["tenant"];
            this.callbackUrl = _data["callbackUrl"];
            this.createdBy = _data["createdBy"];
            this.event = _data["event"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.system = _data["system"];
            this.creatorType = _data["creatorType"];
            this.status = _data["status"];
            this.scope = _data["scope"] ? Scope.fromJS(_data["scope"]) : <any>undefined;
            this.urn = _data["urn"];
            this.filter = _data["filter"];
            this.projectId = _data["projectId"];
            this.hubId = _data["hubId"];
            this.autoReactivateHook = _data["autoReactivateHook"];
            if (_data["hookAttribute"]) {
                this.hookAttribute = {} as any;
                for (let key in _data["hookAttribute"]) {
                    if (_data["hookAttribute"].hasOwnProperty(key))
                        (<any>this.hookAttribute)![key] = _data["hookAttribute"][key];
                }
            }
            this.__self__ = _data["__self__"];
        }
    }

    static fromJS(data: any): Hook {
        data = typeof data === 'object' ? data : {};
        let result = new Hook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hookId"] = this.hookId;
        data["tenant"] = this.tenant;
        data["callbackUrl"] = this.callbackUrl;
        data["createdBy"] = this.createdBy;
        data["event"] = this.event;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["system"] = this.system;
        data["creatorType"] = this.creatorType;
        data["status"] = this.status;
        data["scope"] = this.scope ? this.scope.toJSON() : <any>undefined;
        data["urn"] = this.urn;
        data["filter"] = this.filter;
        data["projectId"] = this.projectId;
        data["hubId"] = this.hubId;
        data["autoReactivateHook"] = this.autoReactivateHook;
        if (this.hookAttribute) {
            data["hookAttribute"] = {};
            for (let key in this.hookAttribute) {
                if (this.hookAttribute.hasOwnProperty(key))
                    (<any>data["hookAttribute"])[key] = (<any>this.hookAttribute)[key];
            }
        }
        data["__self__"] = this.__self__;
        return data;
    }
}

export interface IHook {
    hookId?: string | undefined;
    tenant?: string | undefined;
    callbackUrl?: string | undefined;
    createdBy?: string | undefined;
    event?: string | undefined;
    createdDate?: Date;
    system?: string | undefined;
    creatorType?: string | undefined;
    status?: string | undefined;
    scope?: Scope | undefined;
    urn?: string | undefined;
    filter?: string | undefined;
    projectId?: string | undefined;
    hubId?: string | undefined;
    autoReactivateHook?: boolean;
    hookAttribute?: { [key: string]: any; } | undefined;
    __self__?: string | undefined;
}

export class Hub implements IHub {
    id?: string | undefined;
    name?: string | undefined;
    region?: string | undefined;
    hubType?: HubType;

    constructor(data?: IHub) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.region = _data["region"];
            this.hubType = _data["hubType"];
        }
    }

    static fromJS(data: any): Hub {
        data = typeof data === 'object' ? data : {};
        let result = new Hub();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["region"] = this.region;
        data["hubType"] = this.hubType;
        return data;
    }
}

export interface IHub {
    id?: string | undefined;
    name?: string | undefined;
    region?: string | undefined;
    hubType?: HubType;
}

export enum HubType {
    Unknown = "Unknown",
    A360 = "A360",
    B360Team = "B360Team",
    B360 = "B360",
    Deleted = "Deleted",
}

export class JobBase implements IJobBase {
    id?: string | undefined;
    name?: string | undefined;
    userId?: string | undefined;
    customerId?: string | undefined;
    hubId?: string | undefined;
    projectId?: string | undefined;
    models?: JobFile[] | undefined;
    directories?: JobDirectory[] | undefined;
    scheduleType?: JobScheduleType;
    schedule?: Schedule | undefined;
    lastRun?: JobRunBase | undefined;
    nextRun?: JobRunBase | undefined;
    status?: JobStatusType;
    jobType?: JobType;

    constructor(data?: IJobBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.customerId = _data["customerId"];
            this.hubId = _data["hubId"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(JobFile.fromJS(item));
            }
            if (Array.isArray(_data["directories"])) {
                this.directories = [] as any;
                for (let item of _data["directories"])
                    this.directories!.push(JobDirectory.fromJS(item));
            }
            this.scheduleType = _data["scheduleType"];
            this.schedule = _data["schedule"] ? Schedule.fromJS(_data["schedule"]) : <any>undefined;
            this.lastRun = _data["lastRun"] ? JobRunBase.fromJS(_data["lastRun"]) : <any>undefined;
            this.nextRun = _data["nextRun"] ? JobRunBase.fromJS(_data["nextRun"]) : <any>undefined;
            this.status = _data["status"];
            this.jobType = _data["jobType"];
        }
    }

    static fromJS(data: any): JobBase {
        data = typeof data === 'object' ? data : {};
        let result = new JobBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["customerId"] = this.customerId;
        data["hubId"] = this.hubId;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item.toJSON());
        }
        if (Array.isArray(this.directories)) {
            data["directories"] = [];
            for (let item of this.directories)
                data["directories"].push(item.toJSON());
        }
        data["scheduleType"] = this.scheduleType;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        data["lastRun"] = this.lastRun ? this.lastRun.toJSON() : <any>undefined;
        data["nextRun"] = this.nextRun ? this.nextRun.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["jobType"] = this.jobType;
        return data;
    }
}

export interface IJobBase {
    id?: string | undefined;
    name?: string | undefined;
    userId?: string | undefined;
    customerId?: string | undefined;
    hubId?: string | undefined;
    projectId?: string | undefined;
    models?: JobFile[] | undefined;
    directories?: JobDirectory[] | undefined;
    scheduleType?: JobScheduleType;
    schedule?: Schedule | undefined;
    lastRun?: JobRunBase | undefined;
    nextRun?: JobRunBase | undefined;
    status?: JobStatusType;
    jobType?: JobType;
}

export class JobDataEntry implements IJobDataEntry {
    jobRunDataEntry?: JobRunDataEntry | undefined;
    id?: string | undefined;
    modelStatus?: JobRunItemStatusType;
    sourceModelId?: string | undefined;
    sourceFileNameWithExtension?: string | undefined;
    sourceDirectoryId?: string | undefined;
    sourceDirectoryName?: string | undefined;
    sourceFileSize?: number;
    sourceFileModifiedTime?: Date | undefined;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    developerErrorMessage?: string | undefined;
    fullErrorInfo?: string | undefined;

    constructor(data?: IJobDataEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobRunDataEntry = _data["jobRunDataEntry"] ? JobRunDataEntry.fromJS(_data["jobRunDataEntry"]) : <any>undefined;
            this.id = _data["id"];
            this.modelStatus = _data["modelStatus"];
            this.sourceModelId = _data["sourceModelId"];
            this.sourceFileNameWithExtension = _data["sourceFileNameWithExtension"];
            this.sourceDirectoryId = _data["sourceDirectoryId"];
            this.sourceDirectoryName = _data["sourceDirectoryName"];
            this.sourceFileSize = _data["sourceFileSize"];
            this.sourceFileModifiedTime = _data["sourceFileModifiedTime"] ? new Date(_data["sourceFileModifiedTime"].toString()) : <any>undefined;
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.developerErrorMessage = _data["developerErrorMessage"];
            this.fullErrorInfo = _data["fullErrorInfo"];
        }
    }

    static fromJS(data: any): JobDataEntry {
        data = typeof data === 'object' ? data : {};
        let result = new JobDataEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobRunDataEntry"] = this.jobRunDataEntry ? this.jobRunDataEntry.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["modelStatus"] = this.modelStatus;
        data["sourceModelId"] = this.sourceModelId;
        data["sourceFileNameWithExtension"] = this.sourceFileNameWithExtension;
        data["sourceDirectoryId"] = this.sourceDirectoryId;
        data["sourceDirectoryName"] = this.sourceDirectoryName;
        data["sourceFileSize"] = this.sourceFileSize;
        data["sourceFileModifiedTime"] = this.sourceFileModifiedTime ? this.sourceFileModifiedTime.toISOString() : <any>undefined;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["developerErrorMessage"] = this.developerErrorMessage;
        data["fullErrorInfo"] = this.fullErrorInfo;
        return data;
    }
}

export interface IJobDataEntry {
    jobRunDataEntry?: JobRunDataEntry | undefined;
    id?: string | undefined;
    modelStatus?: JobRunItemStatusType;
    sourceModelId?: string | undefined;
    sourceFileNameWithExtension?: string | undefined;
    sourceDirectoryId?: string | undefined;
    sourceDirectoryName?: string | undefined;
    sourceFileSize?: number;
    sourceFileModifiedTime?: Date | undefined;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    developerErrorMessage?: string | undefined;
    fullErrorInfo?: string | undefined;
}

export class JobDirectory implements IJobDirectory {
    readonly id?: string | undefined;
    readonly name?: string | undefined;
    readonly displayName?: string | undefined;
    readonly parentId?: string | undefined;
    readonly projectId?: string | undefined;
    readonly lastUpdated?: Date;
    readonly lastUpdatedBy?: string | undefined;
    readonly isHidden?: boolean;
    readonly isDirectory?: boolean;
    visibleTypes?: string[] | undefined;
    hubId?: string | undefined;
    hubName?: string | undefined;
    hubType?: HubType;
    region?: string | undefined;
    projectName?: string | undefined;
    projectType?: ProjectType;
    parentName?: string | undefined;
    recursive?: boolean;

    constructor(data?: IJobDirectory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
            (<any>this).displayName = _data["displayName"];
            (<any>this).parentId = _data["parentId"];
            (<any>this).projectId = _data["projectId"];
            (<any>this).lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            (<any>this).lastUpdatedBy = _data["lastUpdatedBy"];
            (<any>this).isHidden = _data["isHidden"];
            (<any>this).isDirectory = _data["isDirectory"];
            if (Array.isArray(_data["visibleTypes"])) {
                this.visibleTypes = [] as any;
                for (let item of _data["visibleTypes"])
                    this.visibleTypes!.push(item);
            }
            this.hubId = _data["hubId"];
            this.hubName = _data["hubName"];
            this.hubType = _data["hubType"];
            this.region = _data["region"];
            this.projectName = _data["projectName"];
            this.projectType = _data["projectType"];
            this.parentName = _data["parentName"];
            this.recursive = _data["recursive"];
        }
    }

    static fromJS(data: any): JobDirectory {
        data = typeof data === 'object' ? data : {};
        let result = new JobDirectory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        data["projectId"] = this.projectId;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["isHidden"] = this.isHidden;
        data["isDirectory"] = this.isDirectory;
        if (Array.isArray(this.visibleTypes)) {
            data["visibleTypes"] = [];
            for (let item of this.visibleTypes)
                data["visibleTypes"].push(item);
        }
        data["hubId"] = this.hubId;
        data["hubName"] = this.hubName;
        data["hubType"] = this.hubType;
        data["region"] = this.region;
        data["projectName"] = this.projectName;
        data["projectType"] = this.projectType;
        data["parentName"] = this.parentName;
        data["recursive"] = this.recursive;
        return data;
    }
}

export interface IJobDirectory {
    id?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    parentId?: string | undefined;
    projectId?: string | undefined;
    lastUpdated?: Date;
    lastUpdatedBy?: string | undefined;
    isHidden?: boolean;
    isDirectory?: boolean;
    visibleTypes?: string[] | undefined;
    hubId?: string | undefined;
    hubName?: string | undefined;
    hubType?: HubType;
    region?: string | undefined;
    projectName?: string | undefined;
    projectType?: ProjectType;
    parentName?: string | undefined;
    recursive?: boolean;
}

export class JobFile implements IJobFile {
    readonly id?: string | undefined;
    readonly name?: string | undefined;
    readonly displayName?: string | undefined;
    readonly parentId?: string | undefined;
    readonly projectId?: string | undefined;
    readonly lastUpdated?: Date;
    readonly lastUpdatedBy?: string | undefined;
    readonly isHidden?: boolean;
    directoryId?: string | undefined;
    fileType?: FileType | undefined;
    thumbnail?: string | undefined;
    readonly isDirectory?: boolean;
    versionNumber?: number;
    objectId?: string | undefined;
    isComposite?: boolean;
    size?: number;
    isLocked?: boolean;
    pathInProject?: string | undefined;
    derivativesId?: string | undefined;
    isProcessed?: boolean;
    compositeParentFile?: string | undefined;
    readonly fileNameWithExtension?: string | undefined;
    hubId?: string | undefined;
    hubName?: string | undefined;
    region?: string | undefined;
    hubType?: HubType;
    projectName?: string | undefined;
    parentName?: string | undefined;
    projectType?: ProjectType;

    constructor(data?: IJobFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
            (<any>this).displayName = _data["displayName"];
            (<any>this).parentId = _data["parentId"];
            (<any>this).projectId = _data["projectId"];
            (<any>this).lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            (<any>this).lastUpdatedBy = _data["lastUpdatedBy"];
            (<any>this).isHidden = _data["isHidden"];
            this.directoryId = _data["directoryId"];
            this.fileType = _data["fileType"] ? FileType.fromJS(_data["fileType"]) : <any>undefined;
            this.thumbnail = _data["thumbnail"];
            (<any>this).isDirectory = _data["isDirectory"];
            this.versionNumber = _data["versionNumber"];
            this.objectId = _data["objectId"];
            this.isComposite = _data["isComposite"];
            this.size = _data["size"];
            this.isLocked = _data["isLocked"];
            this.pathInProject = _data["pathInProject"];
            this.derivativesId = _data["derivativesId"];
            this.isProcessed = _data["isProcessed"];
            this.compositeParentFile = _data["compositeParentFile"];
            (<any>this).fileNameWithExtension = _data["fileNameWithExtension"];
            this.hubId = _data["hubId"];
            this.hubName = _data["hubName"];
            this.region = _data["region"];
            this.hubType = _data["hubType"];
            this.projectName = _data["projectName"];
            this.parentName = _data["parentName"];
            this.projectType = _data["projectType"];
        }
    }

    static fromJS(data: any): JobFile {
        data = typeof data === 'object' ? data : {};
        let result = new JobFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        data["projectId"] = this.projectId;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["isHidden"] = this.isHidden;
        data["directoryId"] = this.directoryId;
        data["fileType"] = this.fileType ? this.fileType.toJSON() : <any>undefined;
        data["thumbnail"] = this.thumbnail;
        data["isDirectory"] = this.isDirectory;
        data["versionNumber"] = this.versionNumber;
        data["objectId"] = this.objectId;
        data["isComposite"] = this.isComposite;
        data["size"] = this.size;
        data["isLocked"] = this.isLocked;
        data["pathInProject"] = this.pathInProject;
        data["derivativesId"] = this.derivativesId;
        data["isProcessed"] = this.isProcessed;
        data["compositeParentFile"] = this.compositeParentFile;
        data["fileNameWithExtension"] = this.fileNameWithExtension;
        data["hubId"] = this.hubId;
        data["hubName"] = this.hubName;
        data["region"] = this.region;
        data["hubType"] = this.hubType;
        data["projectName"] = this.projectName;
        data["parentName"] = this.parentName;
        data["projectType"] = this.projectType;
        return data;
    }
}

export interface IJobFile {
    id?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    parentId?: string | undefined;
    projectId?: string | undefined;
    lastUpdated?: Date;
    lastUpdatedBy?: string | undefined;
    isHidden?: boolean;
    directoryId?: string | undefined;
    fileType?: FileType | undefined;
    thumbnail?: string | undefined;
    isDirectory?: boolean;
    versionNumber?: number;
    objectId?: string | undefined;
    isComposite?: boolean;
    size?: number;
    isLocked?: boolean;
    pathInProject?: string | undefined;
    derivativesId?: string | undefined;
    isProcessed?: boolean;
    compositeParentFile?: string | undefined;
    fileNameWithExtension?: string | undefined;
    hubId?: string | undefined;
    hubName?: string | undefined;
    region?: string | undefined;
    hubType?: HubType;
    projectName?: string | undefined;
    parentName?: string | undefined;
    projectType?: ProjectType;
}

export class JobRunBase implements IJobRunBase {
    id?: string | undefined;
    jobId?: string | undefined;
    customerId?: string | undefined;
    userId?: string | undefined;
    startTime?: Date;
    jobRunItems?: JobRunItemBase[] | undefined;
    status?: JobRunStatusType;

    constructor(data?: IJobRunBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobId = _data["jobId"];
            this.customerId = _data["customerId"];
            this.userId = _data["userId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["jobRunItems"])) {
                this.jobRunItems = [] as any;
                for (let item of _data["jobRunItems"])
                    this.jobRunItems!.push(JobRunItemBase.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): JobRunBase {
        data = typeof data === 'object' ? data : {};
        let result = new JobRunBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobId"] = this.jobId;
        data["customerId"] = this.customerId;
        data["userId"] = this.userId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        if (Array.isArray(this.jobRunItems)) {
            data["jobRunItems"] = [];
            for (let item of this.jobRunItems)
                data["jobRunItems"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IJobRunBase {
    id?: string | undefined;
    jobId?: string | undefined;
    customerId?: string | undefined;
    userId?: string | undefined;
    startTime?: Date;
    jobRunItems?: JobRunItemBase[] | undefined;
    status?: JobRunStatusType;
}

export class JobRunDataEntry implements IJobRunDataEntry {
    runStatus?: JobRunStatusType;
    jobStatus?: JobStatusType;
    jobRunId?: string | undefined;
    jobId?: string | undefined;
    jobName?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
    userId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sourceRunFileCount?: number;
    sourceProjectId?: string | undefined;
    sourceProjectName?: string | undefined;
    sourceProjectType?: ProjectType;
    sourceHubId?: string | undefined;
    sourceHubName?: string | undefined;
    sourceRegion?: string | undefined;
    sourceHubType?: HubType;
    createdDate?: Date | undefined;
    updatedDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    scheduleType?: JobScheduleType;
    jobRunScheduledStartTime?: Date | undefined;
    jobRunActualStartTime?: Date | undefined;
    jobRunActualEndTime?: Date | undefined;
    readonly jobRunDuration?: TimeSpan | undefined;

    constructor(data?: IJobRunDataEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runStatus = _data["runStatus"];
            this.jobStatus = _data["jobStatus"];
            this.jobRunId = _data["jobRunId"];
            this.jobId = _data["jobId"];
            this.jobName = _data["jobName"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.sourceRunFileCount = _data["sourceRunFileCount"];
            this.sourceProjectId = _data["sourceProjectId"];
            this.sourceProjectName = _data["sourceProjectName"];
            this.sourceProjectType = _data["sourceProjectType"];
            this.sourceHubId = _data["sourceHubId"];
            this.sourceHubName = _data["sourceHubName"];
            this.sourceRegion = _data["sourceRegion"];
            this.sourceHubType = _data["sourceHubType"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.scheduleType = _data["scheduleType"];
            this.jobRunScheduledStartTime = _data["jobRunScheduledStartTime"] ? new Date(_data["jobRunScheduledStartTime"].toString()) : <any>undefined;
            this.jobRunActualStartTime = _data["jobRunActualStartTime"] ? new Date(_data["jobRunActualStartTime"].toString()) : <any>undefined;
            this.jobRunActualEndTime = _data["jobRunActualEndTime"] ? new Date(_data["jobRunActualEndTime"].toString()) : <any>undefined;
            (<any>this).jobRunDuration = _data["jobRunDuration"] ? TimeSpan.fromJS(_data["jobRunDuration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JobRunDataEntry {
        data = typeof data === 'object' ? data : {};
        let result = new JobRunDataEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runStatus"] = this.runStatus;
        data["jobStatus"] = this.jobStatus;
        data["jobRunId"] = this.jobRunId;
        data["jobId"] = this.jobId;
        data["jobName"] = this.jobName;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["sourceRunFileCount"] = this.sourceRunFileCount;
        data["sourceProjectId"] = this.sourceProjectId;
        data["sourceProjectName"] = this.sourceProjectName;
        data["sourceProjectType"] = this.sourceProjectType;
        data["sourceHubId"] = this.sourceHubId;
        data["sourceHubName"] = this.sourceHubName;
        data["sourceRegion"] = this.sourceRegion;
        data["sourceHubType"] = this.sourceHubType;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["scheduleType"] = this.scheduleType;
        data["jobRunScheduledStartTime"] = this.jobRunScheduledStartTime ? this.jobRunScheduledStartTime.toISOString() : <any>undefined;
        data["jobRunActualStartTime"] = this.jobRunActualStartTime ? this.jobRunActualStartTime.toISOString() : <any>undefined;
        data["jobRunActualEndTime"] = this.jobRunActualEndTime ? this.jobRunActualEndTime.toISOString() : <any>undefined;
        data["jobRunDuration"] = this.jobRunDuration ? this.jobRunDuration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJobRunDataEntry {
    runStatus?: JobRunStatusType;
    jobStatus?: JobStatusType;
    jobRunId?: string | undefined;
    jobId?: string | undefined;
    jobName?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
    userId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sourceRunFileCount?: number;
    sourceProjectId?: string | undefined;
    sourceProjectName?: string | undefined;
    sourceProjectType?: ProjectType;
    sourceHubId?: string | undefined;
    sourceHubName?: string | undefined;
    sourceRegion?: string | undefined;
    sourceHubType?: HubType;
    createdDate?: Date | undefined;
    updatedDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    scheduleType?: JobScheduleType;
    jobRunScheduledStartTime?: Date | undefined;
    jobRunActualStartTime?: Date | undefined;
    jobRunActualEndTime?: Date | undefined;
    jobRunDuration?: TimeSpan | undefined;
}

export class JobRunItemBase implements IJobRunItemBase {
    id?: string | undefined;
    jobRunId?: string | undefined;
    jobId?: string | undefined;
    customerId?: string | undefined;
    userId?: string | undefined;
    file?: JobFile | undefined;
    status?: JobRunItemStatusType;
    runStartTime?: string | undefined;
    runStartTimeNum?: number;
    errorType?: JobRunItemErrorType | undefined;

    constructor(data?: IJobRunItemBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobRunId = _data["jobRunId"];
            this.jobId = _data["jobId"];
            this.customerId = _data["customerId"];
            this.userId = _data["userId"];
            this.file = _data["file"] ? JobFile.fromJS(_data["file"]) : <any>undefined;
            this.status = _data["status"];
            this.runStartTime = _data["runStartTime"];
            this.runStartTimeNum = _data["runStartTimeNum"];
            this.errorType = _data["errorType"] ? JobRunItemErrorType.fromJS(_data["errorType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JobRunItemBase {
        data = typeof data === 'object' ? data : {};
        let result = new JobRunItemBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobRunId"] = this.jobRunId;
        data["jobId"] = this.jobId;
        data["customerId"] = this.customerId;
        data["userId"] = this.userId;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["runStartTime"] = this.runStartTime;
        data["runStartTimeNum"] = this.runStartTimeNum;
        data["errorType"] = this.errorType ? this.errorType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJobRunItemBase {
    id?: string | undefined;
    jobRunId?: string | undefined;
    jobId?: string | undefined;
    customerId?: string | undefined;
    userId?: string | undefined;
    file?: JobFile | undefined;
    status?: JobRunItemStatusType;
    runStartTime?: string | undefined;
    runStartTimeNum?: number;
    errorType?: JobRunItemErrorType | undefined;
}

export class JobRunItemErrorType implements IJobRunItemErrorType {
    errorCode?: number;
    message?: string | undefined;

    constructor(data?: IJobRunItemErrorType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): JobRunItemErrorType {
        data = typeof data === 'object' ? data : {};
        let result = new JobRunItemErrorType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["message"] = this.message;
        return data;
    }
}

export interface IJobRunItemErrorType {
    errorCode?: number;
    message?: string | undefined;
}

export enum JobRunItemStatusType {
    Pending = "Pending",
    InProgress = "InProgress",
    Cancelled = "Cancelled",
    FailedLimitDataSize = "FailedLimitDataSize",
    FailedLimitProcessingTime = "FailedLimitProcessingTime",
    FailedDownload = "FailedDownload",
    FailedInstructions = "FailedInstructions",
    FailedUpload = "FailedUpload",
    FailedUploadOptional = "FailedUploadOptional",
    Success = "Success",
    Error = "Error",
}

export enum JobRunStatusType {
    Cancelled = "Cancelled",
    Scheduled = "Scheduled",
    Queued = "Queued",
    InProgress = "InProgress",
    PostProcessing = "PostProcessing",
    Success = "Success",
    Error = "Error",
    PartiallyCompleted = "PartiallyCompleted",
}

export enum JobScheduleType {
    None = "None",
    OnceNow = "OnceNow",
    OnceLater = "OnceLater",
    Recurring = "Recurring",
    OnPublish = "OnPublish",
}

export enum JobStatusType {
    None = "None",
    Scheduled = "Scheduled",
    Running = "Running",
    Paused = "Paused",
    Completed = "Completed",
    Error = "Error",
    PostProcessing = "PostProcessing",
    PartiallyCompleted = "PartiallyCompleted",
}

export enum JobType {
    Standard = "Standard",
    DesignAutomation = "DesignAutomation",
}

export class JobUsageDataBase implements IJobUsageDataBase {
    jobId?: string | undefined;
    jobName?: string | undefined;
    jobRunCount?: number;
    readonly level?: UsageDataLevel;
    runTimeSeconds?: number;

    constructor(data?: IJobUsageDataBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.jobName = _data["jobName"];
            this.jobRunCount = _data["jobRunCount"];
            (<any>this).level = _data["level"];
            this.runTimeSeconds = _data["runTimeSeconds"];
        }
    }

    static fromJS(data: any): JobUsageDataBase {
        data = typeof data === 'object' ? data : {};
        let result = new JobUsageDataBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["jobName"] = this.jobName;
        data["jobRunCount"] = this.jobRunCount;
        data["level"] = this.level;
        data["runTimeSeconds"] = this.runTimeSeconds;
        return data;
    }
}

export interface IJobUsageDataBase {
    jobId?: string | undefined;
    jobName?: string | undefined;
    jobRunCount?: number;
    level?: UsageDataLevel;
    runTimeSeconds?: number;
}

export class ListFilesResult implements IListFilesResult {
    files?: File360[] | undefined;
    directories?: Directory360[] | undefined;
    nextPage?: ForgePageData | undefined;
    previousPage?: ForgePageData | undefined;

    constructor(data?: IListFilesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(File360.fromJS(item));
            }
            if (Array.isArray(_data["directories"])) {
                this.directories = [] as any;
                for (let item of _data["directories"])
                    this.directories!.push(Directory360.fromJS(item));
            }
            this.nextPage = _data["nextPage"] ? ForgePageData.fromJS(_data["nextPage"]) : <any>undefined;
            this.previousPage = _data["previousPage"] ? ForgePageData.fromJS(_data["previousPage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListFilesResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListFilesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.directories)) {
            data["directories"] = [];
            for (let item of this.directories)
                data["directories"].push(item.toJSON());
        }
        data["nextPage"] = this.nextPage ? this.nextPage.toJSON() : <any>undefined;
        data["previousPage"] = this.previousPage ? this.previousPage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListFilesResult {
    files?: File360[] | undefined;
    directories?: Directory360[] | undefined;
    nextPage?: ForgePageData | undefined;
    previousPage?: ForgePageData | undefined;
}

export class OverallUsageDataBase implements IOverallUsageDataBase {
    readonly jobRunCount?: number;
    readonly level?: UsageDataLevel;
    readonly runTimeSeconds?: number;
    customerUsageDatas?: CustomerUsageDataBase[] | undefined;

    constructor(data?: IOverallUsageDataBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).jobRunCount = _data["jobRunCount"];
            (<any>this).level = _data["level"];
            (<any>this).runTimeSeconds = _data["runTimeSeconds"];
            if (Array.isArray(_data["customerUsageDatas"])) {
                this.customerUsageDatas = [] as any;
                for (let item of _data["customerUsageDatas"])
                    this.customerUsageDatas!.push(CustomerUsageDataBase.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OverallUsageDataBase {
        data = typeof data === 'object' ? data : {};
        let result = new OverallUsageDataBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobRunCount"] = this.jobRunCount;
        data["level"] = this.level;
        data["runTimeSeconds"] = this.runTimeSeconds;
        if (Array.isArray(this.customerUsageDatas)) {
            data["customerUsageDatas"] = [];
            for (let item of this.customerUsageDatas)
                data["customerUsageDatas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOverallUsageDataBase {
    jobRunCount?: number;
    level?: UsageDataLevel;
    runTimeSeconds?: number;
    customerUsageDatas?: CustomerUsageDataBase[] | undefined;
}

export class PaginationData implements IPaginationData {
    paginationToken?: string | undefined;
    limit?: number;

    constructor(data?: IPaginationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paginationToken = _data["paginationToken"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): PaginationData {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paginationToken"] = this.paginationToken;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IPaginationData {
    paginationToken?: string | undefined;
    limit?: number;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export class Project implements IProject {
    hubId?: string | undefined;
    hubName?: string | undefined;
    hubRegion?: string | undefined;
    readonly hubType?: HubType;
    id?: string | undefined;
    name?: string | undefined;
    rootDirectoryId?: string | undefined;
    imageUrl?: string | undefined;
    projectType?: ProjectType;
    readonly isBim360Project?: boolean;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hubId = _data["hubId"];
            this.hubName = _data["hubName"];
            this.hubRegion = _data["hubRegion"];
            (<any>this).hubType = _data["hubType"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.rootDirectoryId = _data["rootDirectoryId"];
            this.imageUrl = _data["imageUrl"];
            this.projectType = _data["projectType"];
            (<any>this).isBim360Project = _data["isBim360Project"];
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hubId"] = this.hubId;
        data["hubName"] = this.hubName;
        data["hubRegion"] = this.hubRegion;
        data["hubType"] = this.hubType;
        data["id"] = this.id;
        data["name"] = this.name;
        data["rootDirectoryId"] = this.rootDirectoryId;
        data["imageUrl"] = this.imageUrl;
        data["projectType"] = this.projectType;
        data["isBim360Project"] = this.isBim360Project;
        return data;
    }
}

export interface IProject {
    hubId?: string | undefined;
    hubName?: string | undefined;
    hubRegion?: string | undefined;
    hubType?: HubType;
    id?: string | undefined;
    name?: string | undefined;
    rootDirectoryId?: string | undefined;
    imageUrl?: string | undefined;
    projectType?: ProjectType;
    isBim360Project?: boolean;
}

export enum ProjectType {
    Unknown = "Unknown",
    A360 = "A360",
    B360Team = "B360Team",
    B360Docs = "B360Docs",
    ACC = "ACC",
    Deleted = "Deleted",
}

export class RvtVersionResponse implements IRvtVersionResponse {
    revitVersion?: string | undefined;
    derivativesId?: string | undefined;

    constructor(data?: IRvtVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revitVersion = _data["revitVersion"];
            this.derivativesId = _data["derivativesId"];
        }
    }

    static fromJS(data: any): RvtVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RvtVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revitVersion"] = this.revitVersion;
        data["derivativesId"] = this.derivativesId;
        return data;
    }
}

export interface IRvtVersionResponse {
    revitVersion?: string | undefined;
    derivativesId?: string | undefined;
}

export class Schedule implements ISchedule {
    cronString?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    maxRuns?: number;
    isPaused?: boolean;

    constructor(data?: ISchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cronString = _data["cronString"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.maxRuns = _data["maxRuns"];
            this.isPaused = _data["isPaused"];
        }
    }

    static fromJS(data: any): Schedule {
        data = typeof data === 'object' ? data : {};
        let result = new Schedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cronString"] = this.cronString;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["maxRuns"] = this.maxRuns;
        data["isPaused"] = this.isPaused;
        return data;
    }
}

export interface ISchedule {
    cronString?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    maxRuns?: number;
    isPaused?: boolean;
}

export class Scope implements IScope {
    folder?: string | undefined;

    constructor(data?: IScope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folder = _data["folder"];
        }
    }

    static fromJS(data: any): Scope {
        data = typeof data === 'object' ? data : {};
        let result = new Scope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folder"] = this.folder;
        return data;
    }
}

export interface IScope {
    folder?: string | undefined;
}

export class StartCsvDownloadResult implements IStartCsvDownloadResult {
    id?: string | undefined;

    constructor(data?: IStartCsvDownloadResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StartCsvDownloadResult {
        data = typeof data === 'object' ? data : {};
        let result = new StartCsvDownloadResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IStartCsvDownloadResult {
    id?: string | undefined;
}

export class TimeSpan implements ITimeSpan {
    ticks?: number;
    readonly days?: number;
    readonly hours?: number;
    readonly milliseconds?: number;
    readonly minutes?: number;
    readonly seconds?: number;
    readonly totalDays?: number;
    readonly totalHours?: number;
    readonly totalMilliseconds?: number;
    readonly totalMinutes?: number;
    readonly totalSeconds?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            (<any>this).days = _data["days"];
            (<any>this).hours = _data["hours"];
            (<any>this).milliseconds = _data["milliseconds"];
            (<any>this).minutes = _data["minutes"];
            (<any>this).seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;
}

export enum UsageDataLevel {
    All = "All",
    Customer = "Customer",
    User = "User",
    Job = "Job",
}

export class UsageDownloadDto implements IUsageDownloadDto {
    downloadUrl?: string | undefined;
    fileName?: string | undefined;
    readonly isReady?: boolean;

    constructor(data?: IUsageDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadUrl = _data["downloadUrl"];
            this.fileName = _data["fileName"];
            (<any>this).isReady = _data["isReady"];
        }
    }

    static fromJS(data: any): UsageDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsageDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadUrl"] = this.downloadUrl;
        data["fileName"] = this.fileName;
        data["isReady"] = this.isReady;
        return data;
    }
}

export interface IUsageDownloadDto {
    downloadUrl?: string | undefined;
    fileName?: string | undefined;
    isReady?: boolean;
}

export class UsageFilter implements IUsageFilter {
    customer?: CustomerInfo[] | undefined;
    user?: UserBase[] | undefined;
    job?: JobBase[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IUsageFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customer"])) {
                this.customer = [] as any;
                for (let item of _data["customer"])
                    this.customer!.push(CustomerInfo.fromJS(item));
            }
            if (Array.isArray(_data["user"])) {
                this.user = [] as any;
                for (let item of _data["user"])
                    this.user!.push(UserBase.fromJS(item));
            }
            if (Array.isArray(_data["job"])) {
                this.job = [] as any;
                for (let item of _data["job"])
                    this.job!.push(JobBase.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UsageFilter {
        data = typeof data === 'object' ? data : {};
        let result = new UsageFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customer)) {
            data["customer"] = [];
            for (let item of this.customer)
                data["customer"].push(item.toJSON());
        }
        if (Array.isArray(this.user)) {
            data["user"] = [];
            for (let item of this.user)
                data["user"].push(item.toJSON());
        }
        if (Array.isArray(this.job)) {
            data["job"] = [];
            for (let item of this.job)
                data["job"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUsageFilter {
    customer?: CustomerInfo[] | undefined;
    user?: UserBase[] | undefined;
    job?: JobBase[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export enum UsageSortType {
    Default = "Default",
    Date = "Date",
}

export class UsageSummaryBase implements IUsageSummaryBase {
    paginationDataDictionary?: { [key: string]: PaginationData; } | undefined;
    readonly paginationData?: PaginationData | undefined;
    readonly paginationToken?: string | undefined;
    isDoneDictionary?: { [key: string]: boolean; } | undefined;
    readonly isDone?: boolean;
    data?: OverallUsageDataBase | undefined;
    filter?: UsageFilter | undefined;
    requestTime?: Date;
    jobRuns?: JobRunBase[] | undefined;

    constructor(data?: IUsageSummaryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["paginationDataDictionary"]) {
                this.paginationDataDictionary = {} as any;
                for (let key in _data["paginationDataDictionary"]) {
                    if (_data["paginationDataDictionary"].hasOwnProperty(key))
                        (<any>this.paginationDataDictionary)![key] = _data["paginationDataDictionary"][key] ? PaginationData.fromJS(_data["paginationDataDictionary"][key]) : new PaginationData();
                }
            }
            (<any>this).paginationData = _data["paginationData"] ? PaginationData.fromJS(_data["paginationData"]) : <any>undefined;
            (<any>this).paginationToken = _data["paginationToken"];
            if (_data["isDoneDictionary"]) {
                this.isDoneDictionary = {} as any;
                for (let key in _data["isDoneDictionary"]) {
                    if (_data["isDoneDictionary"].hasOwnProperty(key))
                        (<any>this.isDoneDictionary)![key] = _data["isDoneDictionary"][key];
                }
            }
            (<any>this).isDone = _data["isDone"];
            this.data = _data["data"] ? OverallUsageDataBase.fromJS(_data["data"]) : <any>undefined;
            this.filter = _data["filter"] ? UsageFilter.fromJS(_data["filter"]) : <any>undefined;
            this.requestTime = _data["requestTime"] ? new Date(_data["requestTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["jobRuns"])) {
                this.jobRuns = [] as any;
                for (let item of _data["jobRuns"])
                    this.jobRuns!.push(JobRunBase.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UsageSummaryBase {
        data = typeof data === 'object' ? data : {};
        let result = new UsageSummaryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paginationDataDictionary) {
            data["paginationDataDictionary"] = {};
            for (let key in this.paginationDataDictionary) {
                if (this.paginationDataDictionary.hasOwnProperty(key))
                    (<any>data["paginationDataDictionary"])[key] = this.paginationDataDictionary[key] ? this.paginationDataDictionary[key].toJSON() : <any>undefined;
            }
        }
        data["paginationData"] = this.paginationData ? this.paginationData.toJSON() : <any>undefined;
        data["paginationToken"] = this.paginationToken;
        if (this.isDoneDictionary) {
            data["isDoneDictionary"] = {};
            for (let key in this.isDoneDictionary) {
                if (this.isDoneDictionary.hasOwnProperty(key))
                    (<any>data["isDoneDictionary"])[key] = (<any>this.isDoneDictionary)[key];
            }
        }
        data["isDone"] = this.isDone;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["requestTime"] = this.requestTime ? this.requestTime.toISOString() : <any>undefined;
        if (Array.isArray(this.jobRuns)) {
            data["jobRuns"] = [];
            for (let item of this.jobRuns)
                data["jobRuns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUsageSummaryBase {
    paginationDataDictionary?: { [key: string]: PaginationData; } | undefined;
    paginationData?: PaginationData | undefined;
    paginationToken?: string | undefined;
    isDoneDictionary?: { [key: string]: boolean; } | undefined;
    isDone?: boolean;
    data?: OverallUsageDataBase | undefined;
    filter?: UsageFilter | undefined;
    requestTime?: Date;
    jobRuns?: JobRunBase[] | undefined;
}

export class UserAccount implements IUserAccount {
    id?: string | undefined;
    isTeam?: boolean;

    constructor(data?: IUserAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isTeam = _data["isTeam"];
        }
    }

    static fromJS(data: any): UserAccount {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isTeam"] = this.isTeam;
        return data;
    }
}

export interface IUserAccount {
    id?: string | undefined;
    isTeam?: boolean;
}

export class UserBase implements IUserBase {
    id?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isEmailVerified?: boolean;
    is2FAEnabled?: boolean;
    language?: string | undefined;
    countryCode?: string | undefined;
    profileImages?: UserProfileImages | undefined;

    constructor(data?: IUserBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isEmailVerified = _data["isEmailVerified"];
            this.is2FAEnabled = _data["is2FAEnabled"];
            this.language = _data["language"];
            this.countryCode = _data["countryCode"];
            this.profileImages = _data["profileImages"] ? UserProfileImages.fromJS(_data["profileImages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserBase {
        data = typeof data === 'object' ? data : {};
        let result = new UserBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isEmailVerified"] = this.isEmailVerified;
        data["is2FAEnabled"] = this.is2FAEnabled;
        data["language"] = this.language;
        data["countryCode"] = this.countryCode;
        data["profileImages"] = this.profileImages ? this.profileImages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserBase {
    id?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isEmailVerified?: boolean;
    is2FAEnabled?: boolean;
    language?: string | undefined;
    countryCode?: string | undefined;
    profileImages?: UserProfileImages | undefined;
}

export class UserInfo implements IUserInfo {
    id?: string | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUserInfo {
    id?: string | undefined;
}

export class UserProfileImages implements IUserProfileImages {
    sizeX20?: string | undefined;
    sizeX40?: string | undefined;
    sizeX50?: string | undefined;
    sizeX58?: string | undefined;
    sizeX80?: string | undefined;
    sizeX120?: string | undefined;
    sizeX160?: string | undefined;
    sizeX176?: string | undefined;
    sizeX240?: string | undefined;
    sizeX360?: string | undefined;

    constructor(data?: IUserProfileImages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sizeX20 = _data["sizeX20"];
            this.sizeX40 = _data["sizeX40"];
            this.sizeX50 = _data["sizeX50"];
            this.sizeX58 = _data["sizeX58"];
            this.sizeX80 = _data["sizeX80"];
            this.sizeX120 = _data["sizeX120"];
            this.sizeX160 = _data["sizeX160"];
            this.sizeX176 = _data["sizeX176"];
            this.sizeX240 = _data["sizeX240"];
            this.sizeX360 = _data["sizeX360"];
        }
    }

    static fromJS(data: any): UserProfileImages {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileImages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sizeX20"] = this.sizeX20;
        data["sizeX40"] = this.sizeX40;
        data["sizeX50"] = this.sizeX50;
        data["sizeX58"] = this.sizeX58;
        data["sizeX80"] = this.sizeX80;
        data["sizeX120"] = this.sizeX120;
        data["sizeX160"] = this.sizeX160;
        data["sizeX176"] = this.sizeX176;
        data["sizeX240"] = this.sizeX240;
        data["sizeX360"] = this.sizeX360;
        return data;
    }
}

export interface IUserProfileImages {
    sizeX20?: string | undefined;
    sizeX40?: string | undefined;
    sizeX50?: string | undefined;
    sizeX58?: string | undefined;
    sizeX80?: string | undefined;
    sizeX120?: string | undefined;
    sizeX160?: string | undefined;
    sizeX176?: string | undefined;
    sizeX240?: string | undefined;
    sizeX360?: string | undefined;
}

export class UserUsageDataBase implements IUserUsageDataBase {
    userId?: string | undefined;
    username?: string | undefined;
    readonly jobRunCount?: number;
    readonly level?: UsageDataLevel;
    readonly runTimeSeconds?: number;
    jobUsageDatas?: JobUsageDataBase[] | undefined;

    constructor(data?: IUserUsageDataBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            (<any>this).jobRunCount = _data["jobRunCount"];
            (<any>this).level = _data["level"];
            (<any>this).runTimeSeconds = _data["runTimeSeconds"];
            if (Array.isArray(_data["jobUsageDatas"])) {
                this.jobUsageDatas = [] as any;
                for (let item of _data["jobUsageDatas"])
                    this.jobUsageDatas!.push(JobUsageDataBase.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserUsageDataBase {
        data = typeof data === 'object' ? data : {};
        let result = new UserUsageDataBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["jobRunCount"] = this.jobRunCount;
        data["level"] = this.level;
        data["runTimeSeconds"] = this.runTimeSeconds;
        if (Array.isArray(this.jobUsageDatas)) {
            data["jobUsageDatas"] = [];
            for (let item of this.jobUsageDatas)
                data["jobUsageDatas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserUsageDataBase {
    userId?: string | undefined;
    username?: string | undefined;
    jobRunCount?: number;
    level?: UsageDataLevel;
    runTimeSeconds?: number;
    jobUsageDatas?: JobUsageDataBase[] | undefined;
}

export class Webhook implements IWebhook {
    id?: string | undefined;
    tenant?: string | undefined;
    callbackUrl?: string | undefined;
    createdBy?: string | undefined;
    event?: WebhookEvent;
    createdDate?: Date;
    creatorType?: string | undefined;
    status?: string | undefined;
    urn?: string | undefined;
    folder?: string | undefined;
    system?: string | undefined;
    filter?: string | undefined;
    autoReactivateHook?: boolean;
    attributes?: { [key: string]: WebhookAttribute; } | undefined;
    self?: string | undefined;
    readonly uri?: string | undefined;
    region?: string | undefined;
    hubId?: string | undefined;
    projectId?: string | undefined;

    constructor(data?: IWebhook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenant = _data["tenant"];
            this.callbackUrl = _data["callbackUrl"];
            this.createdBy = _data["createdBy"];
            this.event = _data["event"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.creatorType = _data["creatorType"];
            this.status = _data["status"];
            this.urn = _data["urn"];
            this.folder = _data["folder"];
            this.system = _data["system"];
            this.filter = _data["filter"];
            this.autoReactivateHook = _data["autoReactivateHook"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)![key] = _data["attributes"][key] ? WebhookAttribute.fromJS(_data["attributes"][key]) : new WebhookAttribute();
                }
            }
            this.self = _data["self"];
            (<any>this).uri = _data["uri"];
            this.region = _data["region"];
            this.hubId = _data["hubId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): Webhook {
        data = typeof data === 'object' ? data : {};
        let result = new Webhook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenant"] = this.tenant;
        data["callbackUrl"] = this.callbackUrl;
        data["createdBy"] = this.createdBy;
        data["event"] = this.event;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["creatorType"] = this.creatorType;
        data["status"] = this.status;
        data["urn"] = this.urn;
        data["folder"] = this.folder;
        data["system"] = this.system;
        data["filter"] = this.filter;
        data["autoReactivateHook"] = this.autoReactivateHook;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = this.attributes[key] ? this.attributes[key].toJSON() : <any>undefined;
            }
        }
        data["self"] = this.self;
        data["uri"] = this.uri;
        data["region"] = this.region;
        data["hubId"] = this.hubId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IWebhook {
    id?: string | undefined;
    tenant?: string | undefined;
    callbackUrl?: string | undefined;
    createdBy?: string | undefined;
    event?: WebhookEvent;
    createdDate?: Date;
    creatorType?: string | undefined;
    status?: string | undefined;
    urn?: string | undefined;
    folder?: string | undefined;
    system?: string | undefined;
    filter?: string | undefined;
    autoReactivateHook?: boolean;
    attributes?: { [key: string]: WebhookAttribute; } | undefined;
    self?: string | undefined;
    uri?: string | undefined;
    region?: string | undefined;
    hubId?: string | undefined;
    projectId?: string | undefined;
}

export class WebhookAttribute implements IWebhookAttribute {
    key?: string | undefined;
    readonly attributeType?: WebhookAttributeType;
    readonly stringValue?: string | undefined;
    readonly stringListValue?: string[] | undefined;
    readonly integerValue?: number | undefined;
    readonly integerListValue?: number[] | undefined;
    readonly doubleValue?: number | undefined;
    readonly doubleListValue?: number[] | undefined;
    readonly booleanValue?: boolean | undefined;
    readonly nestedValues?: { [key: string]: WebhookAttribute; } | undefined;

    constructor(data?: IWebhookAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            (<any>this).attributeType = _data["attributeType"];
            (<any>this).stringValue = _data["stringValue"];
            if (Array.isArray(_data["stringListValue"])) {
                (<any>this).stringListValue = [] as any;
                for (let item of _data["stringListValue"])
                    (<any>this).stringListValue!.push(item);
            }
            (<any>this).integerValue = _data["integerValue"];
            if (Array.isArray(_data["integerListValue"])) {
                (<any>this).integerListValue = [] as any;
                for (let item of _data["integerListValue"])
                    (<any>this).integerListValue!.push(item);
            }
            (<any>this).doubleValue = _data["doubleValue"];
            if (Array.isArray(_data["doubleListValue"])) {
                (<any>this).doubleListValue = [] as any;
                for (let item of _data["doubleListValue"])
                    (<any>this).doubleListValue!.push(item);
            }
            (<any>this).booleanValue = _data["booleanValue"];
            if (_data["nestedValues"]) {
                (<any>this).nestedValues = {} as any;
                for (let key in _data["nestedValues"]) {
                    if (_data["nestedValues"].hasOwnProperty(key))
                        (<any>(<any>this).nestedValues)![key] = _data["nestedValues"][key] ? WebhookAttribute.fromJS(_data["nestedValues"][key]) : new WebhookAttribute();
                }
            }
        }
    }

    static fromJS(data: any): WebhookAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["attributeType"] = this.attributeType;
        data["stringValue"] = this.stringValue;
        if (Array.isArray(this.stringListValue)) {
            data["stringListValue"] = [];
            for (let item of this.stringListValue)
                data["stringListValue"].push(item);
        }
        data["integerValue"] = this.integerValue;
        if (Array.isArray(this.integerListValue)) {
            data["integerListValue"] = [];
            for (let item of this.integerListValue)
                data["integerListValue"].push(item);
        }
        data["doubleValue"] = this.doubleValue;
        if (Array.isArray(this.doubleListValue)) {
            data["doubleListValue"] = [];
            for (let item of this.doubleListValue)
                data["doubleListValue"].push(item);
        }
        data["booleanValue"] = this.booleanValue;
        if (this.nestedValues) {
            data["nestedValues"] = {};
            for (let key in this.nestedValues) {
                if (this.nestedValues.hasOwnProperty(key))
                    (<any>data["nestedValues"])[key] = this.nestedValues[key] ? this.nestedValues[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IWebhookAttribute {
    key?: string | undefined;
    attributeType?: WebhookAttributeType;
    stringValue?: string | undefined;
    stringListValue?: string[] | undefined;
    integerValue?: number | undefined;
    integerListValue?: number[] | undefined;
    doubleValue?: number | undefined;
    doubleListValue?: number[] | undefined;
    booleanValue?: boolean | undefined;
    nestedValues?: { [key: string]: WebhookAttribute; } | undefined;
}

export enum WebhookAttributeType {
    None = "None",
    String = "String",
    StringList = "StringList",
    Integer = "Integer",
    IntegerList = "IntegerList",
    Double = "Double",
    DoubleList = "DoubleList",
    Boolean = "Boolean",
    Nested = "Nested",
}

export class WebhookBody implements IWebhookBody {
    version?: string | undefined;
    resourceUrn?: string | undefined;
    hook?: Hook | undefined;
    payload?: WebhookPayload | undefined;

    constructor(data?: IWebhookBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.resourceUrn = _data["resourceUrn"];
            this.hook = _data["hook"] ? Hook.fromJS(_data["hook"]) : <any>undefined;
            this.payload = _data["payload"] ? WebhookPayload.fromJS(_data["payload"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WebhookBody {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["resourceUrn"] = this.resourceUrn;
        data["hook"] = this.hook ? this.hook.toJSON() : <any>undefined;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWebhookBody {
    version?: string | undefined;
    resourceUrn?: string | undefined;
    hook?: Hook | undefined;
    payload?: WebhookPayload | undefined;
}

export enum WebhookEvent {
    VersionAdded = "VersionAdded",
    VersionModified = "VersionModified",
    VersionDeleted = "VersionDeleted",
    VersionMoved = "VersionMoved",
    VersionCopied = "VersionCopied",
    FolderAdded = "FolderAdded",
    FolderModified = "FolderModified",
    FolderDeleted = "FolderDeleted",
    FolderMoved = "FolderMoved",
    FolderCopied = "FolderCopied",
    OperationStarted = "OperationStarted",
    OperationCompleted = "OperationCompleted",
    ExtractionFinished = "ExtractionFinished",
    ExtractionUpdated = "ExtractionUpdated",
    ModelSync = "ModelSync",
    ModelPublish = "ModelPublish",
    AppDeletion = "AppDeletion",
    GdprLock = "GdprLock",
    GdprUnlock = "GdprUnlock",
    GdprDelete = "GdprDelete",
}

export class WebhookPayload implements IWebhookPayload {
    ext?: string | undefined;
    modifiedTime?: string | undefined;
    creator?: string | undefined;
    lineageUrn?: string | undefined;
    sizeInBytes?: number;
    hidden?: boolean;
    indexable?: boolean;
    project?: string | undefined;
    source?: string | undefined;
    version?: string | undefined;
    user_info?: UserInfo | undefined;
    name?: string | undefined;
    createdTime?: string | undefined;
    modifiedBy?: string | undefined;
    state?: string | undefined;
    parentFolderUrn?: string | undefined;
    ancestors?: Ancestor[] | undefined;
    tenant?: string | undefined;

    constructor(data?: IWebhookPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ext = _data["ext"];
            this.modifiedTime = _data["modifiedTime"];
            this.creator = _data["creator"];
            this.lineageUrn = _data["lineageUrn"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.hidden = _data["hidden"];
            this.indexable = _data["indexable"];
            this.project = _data["project"];
            this.source = _data["source"];
            this.version = _data["version"];
            this.user_info = _data["user_info"] ? UserInfo.fromJS(_data["user_info"]) : <any>undefined;
            this.name = _data["name"];
            this.createdTime = _data["createdTime"];
            this.modifiedBy = _data["modifiedBy"];
            this.state = _data["state"];
            this.parentFolderUrn = _data["parentFolderUrn"];
            if (Array.isArray(_data["ancestors"])) {
                this.ancestors = [] as any;
                for (let item of _data["ancestors"])
                    this.ancestors!.push(Ancestor.fromJS(item));
            }
            this.tenant = _data["tenant"];
        }
    }

    static fromJS(data: any): WebhookPayload {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ext"] = this.ext;
        data["modifiedTime"] = this.modifiedTime;
        data["creator"] = this.creator;
        data["lineageUrn"] = this.lineageUrn;
        data["sizeInBytes"] = this.sizeInBytes;
        data["hidden"] = this.hidden;
        data["indexable"] = this.indexable;
        data["project"] = this.project;
        data["source"] = this.source;
        data["version"] = this.version;
        data["user_info"] = this.user_info ? this.user_info.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["createdTime"] = this.createdTime;
        data["modifiedBy"] = this.modifiedBy;
        data["state"] = this.state;
        data["parentFolderUrn"] = this.parentFolderUrn;
        if (Array.isArray(this.ancestors)) {
            data["ancestors"] = [];
            for (let item of this.ancestors)
                data["ancestors"].push(item.toJSON());
        }
        data["tenant"] = this.tenant;
        return data;
    }
}

export interface IWebhookPayload {
    ext?: string | undefined;
    modifiedTime?: string | undefined;
    creator?: string | undefined;
    lineageUrn?: string | undefined;
    sizeInBytes?: number;
    hidden?: boolean;
    indexable?: boolean;
    project?: string | undefined;
    source?: string | undefined;
    version?: string | undefined;
    user_info?: UserInfo | undefined;
    name?: string | undefined;
    createdTime?: string | undefined;
    modifiedBy?: string | undefined;
    state?: string | undefined;
    parentFolderUrn?: string | undefined;
    ancestors?: Ancestor[] | undefined;
    tenant?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}